// This is auto generated files. DO NOT EDIT DIRECTLY

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Bool: any;
  Date: any;
};

export type ArticleListingPage = IContent & IData & {
  __typename?: 'ArticleListingPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  AuthorPages?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  BottomContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  Created?: Maybe<Scalars['Date']>;
  DisableSearchFilter?: Maybe<Scalars['Bool']>;
  /** When checked, this page will not be displayed on the search results page. */
  ExcludeFromSearch?: Maybe<Scalars['Bool']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['String']>;
  IsCommonDraft?: Maybe<Scalars['Bool']>;
  ItemsPerPage?: Maybe<Scalars['Int']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MediaTypeCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Metadata?: Maybe<ArticleListingPageMetadataBlock>;
  Name?: Maybe<Scalars['String']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Description text that is displayed in preview tiles throughout the site. */
  PreviewDescription?: Maybe<Scalars['String']>;
  /** Overrides the default image on the page to be displayed on preview tiles throughout the site. */
  PreviewImage?: Maybe<ContentModelReference>;
  /** Overrides the default title/name on the page to be displayed on preview tiles throughout the site. */
  PreviewTitle?: Maybe<Scalars['String']>;
  RelativePath?: Maybe<Scalars['String']>;
  RouteSegment?: Maybe<Scalars['String']>;
  Saved?: Maybe<Scalars['Date']>;
  SearchCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Shortcut?: Maybe<Scalars['String']>;
  SimpleAddress?: Maybe<Scalars['String']>;
  SiteId?: Maybe<Scalars['String']>;
  StartPublish?: Maybe<Scalars['Date']>;
  StartYear?: Maybe<Scalars['Int']>;
  Status?: Maybe<Scalars['String']>;
  StopPublish?: Maybe<Scalars['Date']>;
  ThemeCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Title?: Maybe<Scalars['String']>;
  TopContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Url?: Maybe<Scalars['String']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _sortOrder?: Maybe<Scalars['Int']>;
  _track?: Maybe<Scalars['String']>;
};


export type ArticleListingPageAuthorPagesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ArticleListingPageBottomContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ArticleListingPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ArticleListingPagePreviewDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ArticleListingPagePreviewTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ArticleListingPageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ArticleListingPageTopContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ArticleListingPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ArticleListingPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ArticleListingPageAutocomplete = {
  __typename?: 'ArticleListingPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FileSize?: Maybe<Array<Maybe<Scalars['String']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MediaTypeCategories?: Maybe<CategoryModelAutocomplete>;
  Metadata?: Maybe<ArticleListingPageMetadataBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PreviewImage?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']>>>;
  SearchCategories?: Maybe<CategoryModelAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']>>>;
  ThemeCategories?: Maybe<CategoryModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ArticleListingPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ArticleListingPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ArticleListingPageAutocompleteFileSizeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ArticleListingPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ArticleListingPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ArticleListingPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ArticleListingPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ArticleListingPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ArticleListingPageAutocompleteStatusArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ArticleListingPageAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ArticleListingPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type ArticleListingPageFacet = {
  __typename?: 'ArticleListingPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AuthorPages?: Maybe<ContentAreaItemModelSearchFacet>;
  BottomContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchFilter?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  ItemsPerPage?: Maybe<Array<Maybe<NumberFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MediaTypeCategories?: Maybe<CategoryModelFacet>;
  Metadata?: Maybe<ArticleListingPageMetadataBlockFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreviewDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PreviewImage?: Maybe<ContentModelReferenceFacet>;
  PreviewTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchCategories?: Maybe<CategoryModelFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  StartYear?: Maybe<Array<Maybe<NumberFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThemeCategories?: Maybe<CategoryModelFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TopContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ArticleListingPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticleListingPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type ArticleListingPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticleListingPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type ArticleListingPageFacetDisableSearchFilterArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticleListingPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticleListingPageFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticleListingPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticleListingPageFacetItemsPerPageArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ArticleListingPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticleListingPageFacetPreviewDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticleListingPageFacetPreviewTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticleListingPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticleListingPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticleListingPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type ArticleListingPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticleListingPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticleListingPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticleListingPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type ArticleListingPageFacetStartYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ArticleListingPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticleListingPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type ArticleListingPageFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticleListingPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticleListingPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticleListingPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ArticleListingPageMetadataBlock = {
  __typename?: 'ArticleListingPageMetadataBlock';
  Description?: Maybe<Scalars['String']>;
  Image?: Maybe<ContentModelReference>;
  NoFollow?: Maybe<Scalars['Bool']>;
  NoIndex?: Maybe<Scalars['Bool']>;
  Title?: Maybe<Scalars['String']>;
};


export type ArticleListingPageMetadataBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ArticleListingPageMetadataBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ArticleListingPageMetadataBlockAutocomplete = {
  __typename?: 'ArticleListingPageMetadataBlockAutocomplete';
  Image?: Maybe<ContentModelReferenceAutocomplete>;
};

export type ArticleListingPageMetadataBlockFacet = {
  __typename?: 'ArticleListingPageMetadataBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  NoFollow?: Maybe<Array<Maybe<StringFacet>>>;
  NoIndex?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ArticleListingPageMetadataBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticleListingPageMetadataBlockFacetNoFollowArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticleListingPageMetadataBlockFacetNoIndexArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticleListingPageMetadataBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ArticleListingPageMetadataBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  NoFollow?: InputMaybe<OrderBy>;
  NoIndex?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type ArticleListingPageMetadataBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  NoFollow?: InputMaybe<BoolFilterInput>;
  NoIndex?: InputMaybe<BoolFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type ArticleListingPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AuthorPages?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  BottomContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchFilter?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  ItemsPerPage?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MediaTypeCategories?: InputMaybe<CategoryModelOrderByInput>;
  Metadata?: InputMaybe<ArticleListingPageMetadataBlockOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewDescription?: InputMaybe<OrderBy>;
  PreviewImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewTitle?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchCategories?: InputMaybe<CategoryModelOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  StartYear?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThemeCategories?: InputMaybe<CategoryModelOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  TopContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ArticleListingPageOutput = {
  __typename?: 'ArticleListingPageOutput';
  autocomplete?: Maybe<ArticleListingPageAutocomplete>;
  cursor?: Maybe<Scalars['String']>;
  facets?: Maybe<ArticleListingPageFacet>;
  item?: Maybe<ArticleListingPage>;
  items?: Maybe<Array<Maybe<ArticleListingPage>>>;
  total?: Maybe<Scalars['Int']>;
};


export type ArticleListingPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type ArticleListingPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AuthorPages?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  BottomContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchFilter?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<StringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  ItemsPerPage?: InputMaybe<IntFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MediaTypeCategories?: InputMaybe<CategoryModelWhereInput>;
  Metadata?: InputMaybe<ArticleListingPageMetadataBlockWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewDescription?: InputMaybe<SearchableStringFilterInput>;
  PreviewImage?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewTitle?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchCategories?: InputMaybe<CategoryModelWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  StartYear?: InputMaybe<IntFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThemeCategories?: InputMaybe<CategoryModelWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TopContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ArticleListingPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ArticleListingPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ArticleListingPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ArticlePage = IContent & IData & {
  __typename?: 'ArticlePage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  ArticlePublishDate?: Maybe<Scalars['Date']>;
  Authors?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  BottomContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  CardPadding?: Maybe<Scalars['String']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  Created?: Maybe<Scalars['Date']>;
  /** When checked, this page will not be displayed on the search results page. */
  ExcludeFromSearch?: Maybe<Scalars['Bool']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['String']>;
  HideRelatedArticles?: Maybe<Scalars['Bool']>;
  /** Aspect ratio: 1/1 */
  Image?: Maybe<ArticlePagePictureProfile>;
  IsCommonDraft?: Maybe<Scalars['Bool']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MediaFile?: Maybe<ContentModelReference>;
  MediaTypeCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Metadata?: Maybe<ArticlePageMetadataBlock>;
  Name?: Maybe<Scalars['String']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Description text that is displayed in preview tiles throughout the site. */
  PreviewDescription?: Maybe<Scalars['String']>;
  /** Overrides the default image on the page to be displayed on preview tiles throughout the site. */
  PreviewImage?: Maybe<ContentModelReference>;
  /** Overrides the default title/name on the page to be displayed on preview tiles throughout the site. */
  PreviewTitle?: Maybe<Scalars['String']>;
  ReadTimeInMins?: Maybe<Scalars['Int']>;
  RelatedArticles?: Maybe<ArticlePageRecommendedArticlesBlock>;
  RelativePath?: Maybe<Scalars['String']>;
  RouteSegment?: Maybe<Scalars['String']>;
  Saved?: Maybe<Scalars['Date']>;
  SearchCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Shortcut?: Maybe<Scalars['String']>;
  SimpleAddress?: Maybe<Scalars['String']>;
  SiteId?: Maybe<Scalars['String']>;
  StartPublish?: Maybe<Scalars['Date']>;
  Status?: Maybe<Scalars['String']>;
  StopPublish?: Maybe<Scalars['Date']>;
  Text?: Maybe<Scalars['String']>;
  ThemeCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Title?: Maybe<Scalars['String']>;
  Url?: Maybe<Scalars['String']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _sortOrder?: Maybe<Scalars['Int']>;
  _track?: Maybe<Scalars['String']>;
};


export type ArticlePageAuthorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ArticlePageBottomContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ArticlePageCardPaddingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ArticlePageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ArticlePagePreviewDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ArticlePagePreviewTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ArticlePageTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ArticlePageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ArticlePage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ArticlePage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ArticlePageAutocomplete = {
  __typename?: 'ArticlePageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FileSize?: Maybe<Array<Maybe<Scalars['String']>>>;
  Image?: Maybe<ArticlePagePictureProfileAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MediaFile?: Maybe<ContentModelReferenceAutocomplete>;
  MediaTypeCategories?: Maybe<CategoryModelAutocomplete>;
  Metadata?: Maybe<ArticlePageMetadataBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PreviewImage?: Maybe<ContentModelReferenceAutocomplete>;
  RelatedArticles?: Maybe<ArticlePageRecommendedArticlesBlockAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']>>>;
  SearchCategories?: Maybe<CategoryModelAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']>>>;
  ThemeCategories?: Maybe<CategoryModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ArticlePageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ArticlePageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ArticlePageAutocompleteFileSizeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ArticlePageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ArticlePageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ArticlePageAutocompleteShortcutArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ArticlePageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ArticlePageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ArticlePageAutocompleteStatusArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ArticlePageAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ArticlePageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type ArticlePageFacet = {
  __typename?: 'ArticlePageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ArticlePublishDate?: Maybe<Array<Maybe<DateFacet>>>;
  Authors?: Maybe<ContentAreaItemModelSearchFacet>;
  BottomContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  CardPadding?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<StringFacet>>>;
  HideRelatedArticles?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ArticlePagePictureProfileFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MediaFile?: Maybe<ContentModelReferenceFacet>;
  MediaTypeCategories?: Maybe<CategoryModelFacet>;
  Metadata?: Maybe<ArticlePageMetadataBlockFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreviewDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PreviewImage?: Maybe<ContentModelReferenceFacet>;
  PreviewTitle?: Maybe<Array<Maybe<StringFacet>>>;
  ReadTimeInMins?: Maybe<Array<Maybe<NumberFacet>>>;
  RelatedArticles?: Maybe<ArticlePageRecommendedArticlesBlockFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchCategories?: Maybe<CategoryModelFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Text?: Maybe<Array<Maybe<StringFacet>>>;
  ThemeCategories?: Maybe<CategoryModelFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ArticlePageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageFacetArticlePublishDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type ArticlePageFacetCardPaddingArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type ArticlePageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type ArticlePageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageFacetHideRelatedArticlesArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageFacetPreviewDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageFacetPreviewTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageFacetReadTimeInMinsArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ArticlePageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type ArticlePageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type ArticlePageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type ArticlePageFacetTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ArticlePageMetadataBlock = {
  __typename?: 'ArticlePageMetadataBlock';
  Description?: Maybe<Scalars['String']>;
  Image?: Maybe<ContentModelReference>;
  NoFollow?: Maybe<Scalars['Bool']>;
  NoIndex?: Maybe<Scalars['Bool']>;
  Title?: Maybe<Scalars['String']>;
};


export type ArticlePageMetadataBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ArticlePageMetadataBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ArticlePageMetadataBlockAutocomplete = {
  __typename?: 'ArticlePageMetadataBlockAutocomplete';
  Image?: Maybe<ContentModelReferenceAutocomplete>;
};

export type ArticlePageMetadataBlockFacet = {
  __typename?: 'ArticlePageMetadataBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  NoFollow?: Maybe<Array<Maybe<StringFacet>>>;
  NoIndex?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ArticlePageMetadataBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageMetadataBlockFacetNoFollowArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageMetadataBlockFacetNoIndexArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageMetadataBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ArticlePageMetadataBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  NoFollow?: InputMaybe<OrderBy>;
  NoIndex?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type ArticlePageMetadataBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  NoFollow?: InputMaybe<BoolFilterInput>;
  NoIndex?: InputMaybe<BoolFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type ArticlePageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  ArticlePublishDate?: InputMaybe<OrderBy>;
  Authors?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  BottomContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  CardPadding?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  HideRelatedArticles?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ArticlePagePictureProfileOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MediaFile?: InputMaybe<ContentModelReferenceOrderByInput>;
  MediaTypeCategories?: InputMaybe<CategoryModelOrderByInput>;
  Metadata?: InputMaybe<ArticlePageMetadataBlockOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewDescription?: InputMaybe<OrderBy>;
  PreviewImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewTitle?: InputMaybe<OrderBy>;
  ReadTimeInMins?: InputMaybe<OrderBy>;
  RelatedArticles?: InputMaybe<ArticlePageRecommendedArticlesBlockOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchCategories?: InputMaybe<CategoryModelOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Text?: InputMaybe<OrderBy>;
  ThemeCategories?: InputMaybe<CategoryModelOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ArticlePageOutput = {
  __typename?: 'ArticlePageOutput';
  autocomplete?: Maybe<ArticlePageAutocomplete>;
  cursor?: Maybe<Scalars['String']>;
  facets?: Maybe<ArticlePageFacet>;
  item?: Maybe<ArticlePage>;
  items?: Maybe<Array<Maybe<ArticlePage>>>;
  total?: Maybe<Scalars['Int']>;
};


export type ArticlePageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type ArticlePagePictureProfile = {
  __typename?: 'ArticlePagePictureProfile';
  DesktopImage?: Maybe<ContentModelReference>;
  MobileImage?: Maybe<ContentModelReference>;
  TabletImage?: Maybe<ContentModelReference>;
};

export type ArticlePagePictureProfileAutocomplete = {
  __typename?: 'ArticlePagePictureProfileAutocomplete';
  DesktopImage?: Maybe<ContentModelReferenceAutocomplete>;
  MobileImage?: Maybe<ContentModelReferenceAutocomplete>;
  TabletImage?: Maybe<ContentModelReferenceAutocomplete>;
};

export type ArticlePagePictureProfileFacet = {
  __typename?: 'ArticlePagePictureProfileFacet';
  DesktopImage?: Maybe<ContentModelReferenceFacet>;
  MobileImage?: Maybe<ContentModelReferenceFacet>;
  TabletImage?: Maybe<ContentModelReferenceFacet>;
};

export type ArticlePagePictureProfileOrderByInput = {
  DesktopImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  MobileImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  TabletImage?: InputMaybe<ContentModelReferenceOrderByInput>;
};

export type ArticlePagePictureProfileWhereInput = {
  DesktopImage?: InputMaybe<ContentModelReferenceWhereInput>;
  MobileImage?: InputMaybe<ContentModelReferenceWhereInput>;
  TabletImage?: InputMaybe<ContentModelReferenceWhereInput>;
};

export type ArticlePageRecommendedArticlesBlock = {
  __typename?: 'ArticlePageRecommendedArticlesBlock';
  ArticlePages?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  ArticlesRootPage?: Maybe<ContentModelReference>;
  CategoryCriteriaOperator?: Maybe<Scalars['Int']>;
  CategoryList?: Maybe<Array<Maybe<CategoryModel>>>;
  DisableAutomatedArticles?: Maybe<Scalars['Bool']>;
  HideText?: Maybe<Scalars['Bool']>;
  HideTitle?: Maybe<Scalars['Bool']>;
  Link?: Maybe<LinkItemNode>;
  MaxTotalArticles?: Maybe<Scalars['Int']>;
  Text?: Maybe<Scalars['String']>;
  Theme?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
};


export type ArticlePageRecommendedArticlesBlockArticlePagesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ArticlePageRecommendedArticlesBlockTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ArticlePageRecommendedArticlesBlockThemeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ArticlePageRecommendedArticlesBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ArticlePageRecommendedArticlesBlockAutocomplete = {
  __typename?: 'ArticlePageRecommendedArticlesBlockAutocomplete';
  ArticlesRootPage?: Maybe<ContentModelReferenceAutocomplete>;
  CategoryList?: Maybe<CategoryModelAutocomplete>;
  Link?: Maybe<LinkItemNodeAutocomplete>;
};

export type ArticlePageRecommendedArticlesBlockFacet = {
  __typename?: 'ArticlePageRecommendedArticlesBlockFacet';
  ArticlePages?: Maybe<ContentAreaItemModelSearchFacet>;
  ArticlesRootPage?: Maybe<ContentModelReferenceFacet>;
  CategoryCriteriaOperator?: Maybe<Array<Maybe<NumberFacet>>>;
  CategoryList?: Maybe<CategoryModelFacet>;
  DisableAutomatedArticles?: Maybe<Array<Maybe<StringFacet>>>;
  HideText?: Maybe<Array<Maybe<StringFacet>>>;
  HideTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Link?: Maybe<LinkItemNodeFacet>;
  MaxTotalArticles?: Maybe<Array<Maybe<NumberFacet>>>;
  Text?: Maybe<Array<Maybe<StringFacet>>>;
  Theme?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ArticlePageRecommendedArticlesBlockFacetCategoryCriteriaOperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ArticlePageRecommendedArticlesBlockFacetDisableAutomatedArticlesArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageRecommendedArticlesBlockFacetHideTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageRecommendedArticlesBlockFacetHideTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageRecommendedArticlesBlockFacetMaxTotalArticlesArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ArticlePageRecommendedArticlesBlockFacetTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageRecommendedArticlesBlockFacetThemeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ArticlePageRecommendedArticlesBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ArticlePageRecommendedArticlesBlockOrderByInput = {
  ArticlePages?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ArticlesRootPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  CategoryCriteriaOperator?: InputMaybe<OrderBy>;
  CategoryList?: InputMaybe<CategoryModelOrderByInput>;
  DisableAutomatedArticles?: InputMaybe<OrderBy>;
  HideText?: InputMaybe<OrderBy>;
  HideTitle?: InputMaybe<OrderBy>;
  Link?: InputMaybe<LinkItemNodeOrderByInput>;
  MaxTotalArticles?: InputMaybe<OrderBy>;
  Text?: InputMaybe<OrderBy>;
  Theme?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type ArticlePageRecommendedArticlesBlockWhereInput = {
  ArticlePages?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ArticlesRootPage?: InputMaybe<ContentModelReferenceWhereInput>;
  CategoryCriteriaOperator?: InputMaybe<IntFilterInput>;
  CategoryList?: InputMaybe<CategoryModelWhereInput>;
  DisableAutomatedArticles?: InputMaybe<BoolFilterInput>;
  HideText?: InputMaybe<BoolFilterInput>;
  HideTitle?: InputMaybe<BoolFilterInput>;
  Link?: InputMaybe<LinkItemNodeWhereInput>;
  MaxTotalArticles?: InputMaybe<IntFilterInput>;
  Text?: InputMaybe<SearchableStringFilterInput>;
  Theme?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type ArticlePageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  ArticlePublishDate?: InputMaybe<DateFilterInput>;
  Authors?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  BottomContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  CardPadding?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<StringFilterInput>;
  HideRelatedArticles?: InputMaybe<BoolFilterInput>;
  Image?: InputMaybe<ArticlePagePictureProfileWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MediaFile?: InputMaybe<ContentModelReferenceWhereInput>;
  MediaTypeCategories?: InputMaybe<CategoryModelWhereInput>;
  Metadata?: InputMaybe<ArticlePageMetadataBlockWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewDescription?: InputMaybe<SearchableStringFilterInput>;
  PreviewImage?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewTitle?: InputMaybe<SearchableStringFilterInput>;
  ReadTimeInMins?: InputMaybe<IntFilterInput>;
  RelatedArticles?: InputMaybe<ArticlePageRecommendedArticlesBlockWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchCategories?: InputMaybe<CategoryModelWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Text?: InputMaybe<SearchableStringFilterInput>;
  ThemeCategories?: InputMaybe<CategoryModelWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ArticlePageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ArticlePageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ArticlePageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type AssetListingPage = IContent & IData & {
  __typename?: 'AssetListingPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  AssetTypeCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  BottomContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  Countries?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Created?: Maybe<Scalars['Date']>;
  DisableSearchFilter?: Maybe<Scalars['Bool']>;
  /** When checked, this page will not be displayed on the search results page. */
  ExcludeFromSearch?: Maybe<Scalars['Bool']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['String']>;
  IsCommonDraft?: Maybe<Scalars['Bool']>;
  ItemsPerPage?: Maybe<Scalars['Int']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Metadata?: Maybe<AssetListingPageMetadataBlock>;
  Name?: Maybe<Scalars['String']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Description text that is displayed in preview tiles throughout the site. */
  PreviewDescription?: Maybe<Scalars['String']>;
  /** Overrides the default image on the page to be displayed on preview tiles throughout the site. */
  PreviewImage?: Maybe<ContentModelReference>;
  /** Overrides the default title/name on the page to be displayed on preview tiles throughout the site. */
  PreviewTitle?: Maybe<Scalars['String']>;
  RelativePath?: Maybe<Scalars['String']>;
  RouteSegment?: Maybe<Scalars['String']>;
  Saved?: Maybe<Scalars['Date']>;
  SearchCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  SectorCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Shortcut?: Maybe<Scalars['String']>;
  SimpleAddress?: Maybe<Scalars['String']>;
  SiteId?: Maybe<Scalars['String']>;
  StartPublish?: Maybe<Scalars['Date']>;
  StartYear?: Maybe<Scalars['Int']>;
  Status?: Maybe<Scalars['String']>;
  StopPublish?: Maybe<Scalars['Date']>;
  Title?: Maybe<Scalars['String']>;
  TopContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Url?: Maybe<Scalars['String']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _sortOrder?: Maybe<Scalars['Int']>;
  _track?: Maybe<Scalars['String']>;
};


export type AssetListingPageBottomContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssetListingPageCountriesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssetListingPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssetListingPagePreviewDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssetListingPagePreviewTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssetListingPageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssetListingPageTopContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssetListingPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssetListingPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type AssetListingPageAutocomplete = {
  __typename?: 'AssetListingPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  AssetTypeCategories?: Maybe<CategoryModelAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FileSize?: Maybe<Array<Maybe<Scalars['String']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  Metadata?: Maybe<AssetListingPageMetadataBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PreviewImage?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']>>>;
  SearchCategories?: Maybe<CategoryModelAutocomplete>;
  SectorCategories?: Maybe<CategoryModelAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type AssetListingPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type AssetListingPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type AssetListingPageAutocompleteFileSizeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type AssetListingPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type AssetListingPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type AssetListingPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type AssetListingPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type AssetListingPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type AssetListingPageAutocompleteStatusArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type AssetListingPageAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type AssetListingPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type AssetListingPageFacet = {
  __typename?: 'AssetListingPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssetTypeCategories?: Maybe<CategoryModelFacet>;
  BottomContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Countries?: Maybe<ContentAreaItemModelSearchFacet>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchFilter?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  ItemsPerPage?: Maybe<Array<Maybe<NumberFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Metadata?: Maybe<AssetListingPageMetadataBlockFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreviewDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PreviewImage?: Maybe<ContentModelReferenceFacet>;
  PreviewTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchCategories?: Maybe<CategoryModelFacet>;
  SectorCategories?: Maybe<CategoryModelFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  StartYear?: Maybe<Array<Maybe<NumberFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TopContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type AssetListingPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetListingPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type AssetListingPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetListingPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type AssetListingPageFacetDisableSearchFilterArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetListingPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetListingPageFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetListingPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetListingPageFacetItemsPerPageArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type AssetListingPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetListingPageFacetPreviewDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetListingPageFacetPreviewTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetListingPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetListingPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetListingPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type AssetListingPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetListingPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetListingPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetListingPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type AssetListingPageFacetStartYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type AssetListingPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetListingPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type AssetListingPageFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetListingPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetListingPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetListingPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type AssetListingPageMetadataBlock = {
  __typename?: 'AssetListingPageMetadataBlock';
  Description?: Maybe<Scalars['String']>;
  Image?: Maybe<ContentModelReference>;
  NoFollow?: Maybe<Scalars['Bool']>;
  NoIndex?: Maybe<Scalars['Bool']>;
  Title?: Maybe<Scalars['String']>;
};


export type AssetListingPageMetadataBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssetListingPageMetadataBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type AssetListingPageMetadataBlockAutocomplete = {
  __typename?: 'AssetListingPageMetadataBlockAutocomplete';
  Image?: Maybe<ContentModelReferenceAutocomplete>;
};

export type AssetListingPageMetadataBlockFacet = {
  __typename?: 'AssetListingPageMetadataBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  NoFollow?: Maybe<Array<Maybe<StringFacet>>>;
  NoIndex?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type AssetListingPageMetadataBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetListingPageMetadataBlockFacetNoFollowArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetListingPageMetadataBlockFacetNoIndexArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetListingPageMetadataBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AssetListingPageMetadataBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  NoFollow?: InputMaybe<OrderBy>;
  NoIndex?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type AssetListingPageMetadataBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  NoFollow?: InputMaybe<BoolFilterInput>;
  NoIndex?: InputMaybe<BoolFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type AssetListingPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AssetTypeCategories?: InputMaybe<CategoryModelOrderByInput>;
  BottomContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Countries?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchFilter?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  ItemsPerPage?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Metadata?: InputMaybe<AssetListingPageMetadataBlockOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewDescription?: InputMaybe<OrderBy>;
  PreviewImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewTitle?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchCategories?: InputMaybe<CategoryModelOrderByInput>;
  SectorCategories?: InputMaybe<CategoryModelOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  StartYear?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  TopContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type AssetListingPageOutput = {
  __typename?: 'AssetListingPageOutput';
  autocomplete?: Maybe<AssetListingPageAutocomplete>;
  cursor?: Maybe<Scalars['String']>;
  facets?: Maybe<AssetListingPageFacet>;
  item?: Maybe<AssetListingPage>;
  items?: Maybe<Array<Maybe<AssetListingPage>>>;
  total?: Maybe<Scalars['Int']>;
};


export type AssetListingPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type AssetListingPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AssetTypeCategories?: InputMaybe<CategoryModelWhereInput>;
  BottomContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Countries?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchFilter?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<StringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  ItemsPerPage?: InputMaybe<IntFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Metadata?: InputMaybe<AssetListingPageMetadataBlockWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewDescription?: InputMaybe<SearchableStringFilterInput>;
  PreviewImage?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewTitle?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchCategories?: InputMaybe<CategoryModelWhereInput>;
  SectorCategories?: InputMaybe<CategoryModelWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  StartYear?: InputMaybe<IntFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TopContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<AssetListingPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<AssetListingPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<AssetListingPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type AssetPage = IContent & IData & {
  __typename?: 'AssetPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  AssetTableFootnote?: Maybe<Scalars['String']>;
  AssetTypeCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  BodyContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  CountryItems?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Created?: Maybe<Scalars['Date']>;
  DateAcquired?: Maybe<Scalars['Date']>;
  Description?: Maybe<Scalars['String']>;
  /** When checked, this page will not be displayed on the search results page. */
  ExcludeFromSearch?: Maybe<Scalars['Bool']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['String']>;
  HeadOffice?: Maybe<ContentModelReference>;
  /** Aspect ratio: 16/9 */
  Image?: Maybe<AssetPagePictureProfile>;
  IsCommonDraft?: Maybe<Scalars['Bool']>;
  Language?: Maybe<ContentLanguageModel>;
  Latitude?: Maybe<Scalars['String']>;
  Longitude?: Maybe<Scalars['String']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Metadata?: Maybe<AssetPageMetadataBlock>;
  Name?: Maybe<Scalars['String']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Description text that is displayed in preview tiles throughout the site. */
  PreviewDescription?: Maybe<Scalars['String']>;
  /** Overrides the default image on the page to be displayed on preview tiles throughout the site. */
  PreviewImage?: Maybe<ContentModelReference>;
  /** Overrides the default title/name on the page to be displayed on preview tiles throughout the site. */
  PreviewTitle?: Maybe<Scalars['String']>;
  RelativePath?: Maybe<Scalars['String']>;
  RouteSegment?: Maybe<Scalars['String']>;
  Saved?: Maybe<Scalars['Date']>;
  SearchCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  SectorCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Shortcut?: Maybe<Scalars['String']>;
  SimpleAddress?: Maybe<Scalars['String']>;
  SiteId?: Maybe<Scalars['String']>;
  StartPublish?: Maybe<Scalars['Date']>;
  Status?: Maybe<Scalars['String']>;
  StopPublish?: Maybe<Scalars['Date']>;
  Title?: Maybe<Scalars['String']>;
  Url?: Maybe<Scalars['String']>;
  WebsiteLink?: Maybe<LinkItemNode>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _sortOrder?: Maybe<Scalars['Int']>;
  _track?: Maybe<Scalars['String']>;
};


export type AssetPageAssetTableFootnoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssetPageBodyContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssetPageCountryItemsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssetPageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssetPageLatitudeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssetPageLongitudeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssetPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssetPagePreviewDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssetPagePreviewTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssetPageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssetPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssetPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type AssetPageAutocomplete = {
  __typename?: 'AssetPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  AssetTypeCategories?: Maybe<CategoryModelAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FileSize?: Maybe<Array<Maybe<Scalars['String']>>>;
  HeadOffice?: Maybe<ContentModelReferenceAutocomplete>;
  Image?: Maybe<AssetPagePictureProfileAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  Metadata?: Maybe<AssetPageMetadataBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PreviewImage?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']>>>;
  SearchCategories?: Maybe<CategoryModelAutocomplete>;
  SectorCategories?: Maybe<CategoryModelAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
  WebsiteLink?: Maybe<LinkItemNodeAutocomplete>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type AssetPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type AssetPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type AssetPageAutocompleteFileSizeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type AssetPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type AssetPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type AssetPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type AssetPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type AssetPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type AssetPageAutocompleteStatusArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type AssetPageAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type AssetPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type AssetPageFacet = {
  __typename?: 'AssetPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssetTableFootnote?: Maybe<Array<Maybe<StringFacet>>>;
  AssetTypeCategories?: Maybe<CategoryModelFacet>;
  BodyContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CountryItems?: Maybe<ContentAreaItemModelSearchFacet>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DateAcquired?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<StringFacet>>>;
  HeadOffice?: Maybe<ContentModelReferenceFacet>;
  Image?: Maybe<AssetPagePictureProfileFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  Latitude?: Maybe<Array<Maybe<StringFacet>>>;
  Longitude?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Metadata?: Maybe<AssetPageMetadataBlockFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreviewDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PreviewImage?: Maybe<ContentModelReferenceFacet>;
  PreviewTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchCategories?: Maybe<CategoryModelFacet>;
  SectorCategories?: Maybe<CategoryModelFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WebsiteLink?: Maybe<LinkItemNodeFacet>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type AssetPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageFacetAssetTableFootnoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type AssetPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type AssetPageFacetDateAcquiredArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type AssetPageFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageFacetLatitudeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageFacetLongitudeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageFacetPreviewDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageFacetPreviewTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type AssetPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type AssetPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type AssetPageFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type AssetPageMetadataBlock = {
  __typename?: 'AssetPageMetadataBlock';
  Description?: Maybe<Scalars['String']>;
  Image?: Maybe<ContentModelReference>;
  NoFollow?: Maybe<Scalars['Bool']>;
  NoIndex?: Maybe<Scalars['Bool']>;
  Title?: Maybe<Scalars['String']>;
};


export type AssetPageMetadataBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssetPageMetadataBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type AssetPageMetadataBlockAutocomplete = {
  __typename?: 'AssetPageMetadataBlockAutocomplete';
  Image?: Maybe<ContentModelReferenceAutocomplete>;
};

export type AssetPageMetadataBlockFacet = {
  __typename?: 'AssetPageMetadataBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  NoFollow?: Maybe<Array<Maybe<StringFacet>>>;
  NoIndex?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type AssetPageMetadataBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageMetadataBlockFacetNoFollowArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageMetadataBlockFacetNoIndexArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssetPageMetadataBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AssetPageMetadataBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  NoFollow?: InputMaybe<OrderBy>;
  NoIndex?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type AssetPageMetadataBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  NoFollow?: InputMaybe<BoolFilterInput>;
  NoIndex?: InputMaybe<BoolFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type AssetPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AssetTableFootnote?: InputMaybe<OrderBy>;
  AssetTypeCategories?: InputMaybe<CategoryModelOrderByInput>;
  BodyContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CountryItems?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Created?: InputMaybe<OrderBy>;
  DateAcquired?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  HeadOffice?: InputMaybe<ContentModelReferenceOrderByInput>;
  Image?: InputMaybe<AssetPagePictureProfileOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Latitude?: InputMaybe<OrderBy>;
  Longitude?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Metadata?: InputMaybe<AssetPageMetadataBlockOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewDescription?: InputMaybe<OrderBy>;
  PreviewImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewTitle?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchCategories?: InputMaybe<CategoryModelOrderByInput>;
  SectorCategories?: InputMaybe<CategoryModelOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WebsiteLink?: InputMaybe<LinkItemNodeOrderByInput>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type AssetPageOutput = {
  __typename?: 'AssetPageOutput';
  autocomplete?: Maybe<AssetPageAutocomplete>;
  cursor?: Maybe<Scalars['String']>;
  facets?: Maybe<AssetPageFacet>;
  item?: Maybe<AssetPage>;
  items?: Maybe<Array<Maybe<AssetPage>>>;
  total?: Maybe<Scalars['Int']>;
};


export type AssetPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type AssetPagePictureProfile = {
  __typename?: 'AssetPagePictureProfile';
  DesktopImage?: Maybe<ContentModelReference>;
  MobileImage?: Maybe<ContentModelReference>;
  TabletImage?: Maybe<ContentModelReference>;
};

export type AssetPagePictureProfileAutocomplete = {
  __typename?: 'AssetPagePictureProfileAutocomplete';
  DesktopImage?: Maybe<ContentModelReferenceAutocomplete>;
  MobileImage?: Maybe<ContentModelReferenceAutocomplete>;
  TabletImage?: Maybe<ContentModelReferenceAutocomplete>;
};

export type AssetPagePictureProfileFacet = {
  __typename?: 'AssetPagePictureProfileFacet';
  DesktopImage?: Maybe<ContentModelReferenceFacet>;
  MobileImage?: Maybe<ContentModelReferenceFacet>;
  TabletImage?: Maybe<ContentModelReferenceFacet>;
};

export type AssetPagePictureProfileOrderByInput = {
  DesktopImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  MobileImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  TabletImage?: InputMaybe<ContentModelReferenceOrderByInput>;
};

export type AssetPagePictureProfileWhereInput = {
  DesktopImage?: InputMaybe<ContentModelReferenceWhereInput>;
  MobileImage?: InputMaybe<ContentModelReferenceWhereInput>;
  TabletImage?: InputMaybe<ContentModelReferenceWhereInput>;
};

export type AssetPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AssetTableFootnote?: InputMaybe<SearchableStringFilterInput>;
  AssetTypeCategories?: InputMaybe<CategoryModelWhereInput>;
  BodyContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CountryItems?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Created?: InputMaybe<DateFilterInput>;
  DateAcquired?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<StringFilterInput>;
  HeadOffice?: InputMaybe<ContentModelReferenceWhereInput>;
  Image?: InputMaybe<AssetPagePictureProfileWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Latitude?: InputMaybe<SearchableStringFilterInput>;
  Longitude?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Metadata?: InputMaybe<AssetPageMetadataBlockWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewDescription?: InputMaybe<SearchableStringFilterInput>;
  PreviewImage?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewTitle?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchCategories?: InputMaybe<CategoryModelWhereInput>;
  SectorCategories?: InputMaybe<CategoryModelWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  WebsiteLink?: InputMaybe<LinkItemNodeWhereInput>;
  _and?: InputMaybe<Array<InputMaybe<AssetPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<AssetPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<AssetPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type BlobModel = {
  __typename?: 'BlobModel';
  Id?: Maybe<Scalars['String']>;
  Url?: Maybe<Scalars['String']>;
};

export type BlobModelAutocomplete = {
  __typename?: 'BlobModelAutocomplete';
  Id?: Maybe<Array<Maybe<Scalars['String']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type BlobModelAutocompleteIdArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type BlobModelAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type BlobModelFacet = {
  __typename?: 'BlobModelFacet';
  Id?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
};


export type BlobModelFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BlobModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlobModelOrderByInput = {
  Id?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
};

export type BlobModelWhereInput = {
  Id?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
};

export type BoolFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['Boolean']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['Boolean']>;
};

export type CalculatorDefaultPage = IContent & IData & {
  __typename?: 'CalculatorDefaultPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  BottomContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  CalculateText?: Maybe<Scalars['String']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']>;
  /** Text for Each additional unit of cover */
  ColumnAdditionalCoverText?: Maybe<Scalars['String']>;
  /** Text for Default Death and Total & Permanent Disablement cover */
  ColumnDefaultCoverText?: Maybe<Scalars['String']>;
  /** Text for Weekly Insurance Fee for default cover */
  ColumnWeeklyRateText?: Maybe<Scalars['String']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  Created?: Maybe<Scalars['Date']>;
  DesktopImage?: Maybe<ContentModelReference>;
  /** When checked, this page will not be displayed on the search results page. */
  ExcludeFromSearch?: Maybe<Scalars['Bool']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['String']>;
  /** Text at the bottom of the calculation result table */
  InfoText?: Maybe<Scalars['String']>;
  IsCommonDraft?: Maybe<Scalars['Bool']>;
  LabelAge?: Maybe<Scalars['String']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Metadata?: Maybe<CalculatorDefaultPageMetadataBlock>;
  Name?: Maybe<Scalars['String']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Description text that is displayed in preview tiles throughout the site. */
  PreviewDescription?: Maybe<Scalars['String']>;
  /** Overrides the default image on the page to be displayed on preview tiles throughout the site. */
  PreviewImage?: Maybe<ContentModelReference>;
  /** Overrides the default title/name on the page to be displayed on preview tiles throughout the site. */
  PreviewTitle?: Maybe<Scalars['String']>;
  RelativePath?: Maybe<Scalars['String']>;
  RouteSegment?: Maybe<Scalars['String']>;
  RowDeathCoverText?: Maybe<Scalars['String']>;
  RowTPDCoverText?: Maybe<Scalars['String']>;
  Saved?: Maybe<Scalars['Date']>;
  SearchCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Shortcut?: Maybe<Scalars['String']>;
  SimpleAddress?: Maybe<Scalars['String']>;
  SiteId?: Maybe<Scalars['String']>;
  StartPublish?: Maybe<Scalars['Date']>;
  Status?: Maybe<Scalars['String']>;
  StopPublish?: Maybe<Scalars['Date']>;
  SubTitle?: Maybe<Scalars['String']>;
  TableTitle?: Maybe<Scalars['String']>;
  TitleText?: Maybe<Scalars['String']>;
  TopContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Url?: Maybe<Scalars['String']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _sortOrder?: Maybe<Scalars['Int']>;
  _track?: Maybe<Scalars['String']>;
};


export type CalculatorDefaultPageBottomContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorDefaultPageCalculateTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorDefaultPageColumnAdditionalCoverTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorDefaultPageColumnDefaultCoverTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorDefaultPageColumnWeeklyRateTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorDefaultPageInfoTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorDefaultPageLabelAgeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorDefaultPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorDefaultPagePreviewDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorDefaultPagePreviewTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorDefaultPageRowDeathCoverTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorDefaultPageRowTpdCoverTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorDefaultPageSubTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorDefaultPageTableTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorDefaultPageTitleTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorDefaultPageTopContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorDefaultPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorDefaultPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CalculatorDefaultPageAutocomplete = {
  __typename?: 'CalculatorDefaultPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  DesktopImage?: Maybe<ContentModelReferenceAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FileSize?: Maybe<Array<Maybe<Scalars['String']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  Metadata?: Maybe<CalculatorDefaultPageMetadataBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PreviewImage?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']>>>;
  SearchCategories?: Maybe<CategoryModelAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CalculatorDefaultPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorDefaultPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorDefaultPageAutocompleteFileSizeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorDefaultPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorDefaultPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorDefaultPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorDefaultPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorDefaultPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorDefaultPageAutocompleteStatusArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorDefaultPageAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorDefaultPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type CalculatorDefaultPageFacet = {
  __typename?: 'CalculatorDefaultPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BottomContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  CalculateText?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ColumnAdditionalCoverText?: Maybe<Array<Maybe<StringFacet>>>;
  ColumnDefaultCoverText?: Maybe<Array<Maybe<StringFacet>>>;
  ColumnWeeklyRateText?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DesktopImage?: Maybe<ContentModelReferenceFacet>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<StringFacet>>>;
  InfoText?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  LabelAge?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Metadata?: Maybe<CalculatorDefaultPageMetadataBlockFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreviewDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PreviewImage?: Maybe<ContentModelReferenceFacet>;
  PreviewTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  RowDeathCoverText?: Maybe<Array<Maybe<StringFacet>>>;
  RowTPDCoverText?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchCategories?: Maybe<CategoryModelFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubTitle?: Maybe<Array<Maybe<StringFacet>>>;
  TableTitle?: Maybe<Array<Maybe<StringFacet>>>;
  TitleText?: Maybe<Array<Maybe<StringFacet>>>;
  TopContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CalculatorDefaultPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetCalculateTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type CalculatorDefaultPageFacetColumnAdditionalCoverTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetColumnDefaultCoverTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetColumnWeeklyRateTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type CalculatorDefaultPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetInfoTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetLabelAgeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetPreviewDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetPreviewTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetRowDeathCoverTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetRowTpdCoverTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type CalculatorDefaultPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type CalculatorDefaultPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type CalculatorDefaultPageFacetSubTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetTableTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetTitleTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CalculatorDefaultPageMetadataBlock = {
  __typename?: 'CalculatorDefaultPageMetadataBlock';
  Description?: Maybe<Scalars['String']>;
  Image?: Maybe<ContentModelReference>;
  NoFollow?: Maybe<Scalars['Bool']>;
  NoIndex?: Maybe<Scalars['Bool']>;
  Title?: Maybe<Scalars['String']>;
};


export type CalculatorDefaultPageMetadataBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorDefaultPageMetadataBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CalculatorDefaultPageMetadataBlockAutocomplete = {
  __typename?: 'CalculatorDefaultPageMetadataBlockAutocomplete';
  Image?: Maybe<ContentModelReferenceAutocomplete>;
};

export type CalculatorDefaultPageMetadataBlockFacet = {
  __typename?: 'CalculatorDefaultPageMetadataBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  NoFollow?: Maybe<Array<Maybe<StringFacet>>>;
  NoIndex?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CalculatorDefaultPageMetadataBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageMetadataBlockFacetNoFollowArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageMetadataBlockFacetNoIndexArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorDefaultPageMetadataBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorDefaultPageMetadataBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  NoFollow?: InputMaybe<OrderBy>;
  NoIndex?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type CalculatorDefaultPageMetadataBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  NoFollow?: InputMaybe<BoolFilterInput>;
  NoIndex?: InputMaybe<BoolFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type CalculatorDefaultPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BottomContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  CalculateText?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ColumnAdditionalCoverText?: InputMaybe<OrderBy>;
  ColumnDefaultCoverText?: InputMaybe<OrderBy>;
  ColumnWeeklyRateText?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DesktopImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  InfoText?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  LabelAge?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Metadata?: InputMaybe<CalculatorDefaultPageMetadataBlockOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewDescription?: InputMaybe<OrderBy>;
  PreviewImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewTitle?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  RowDeathCoverText?: InputMaybe<OrderBy>;
  RowTPDCoverText?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchCategories?: InputMaybe<CategoryModelOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubTitle?: InputMaybe<OrderBy>;
  TableTitle?: InputMaybe<OrderBy>;
  TitleText?: InputMaybe<OrderBy>;
  TopContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CalculatorDefaultPageOutput = {
  __typename?: 'CalculatorDefaultPageOutput';
  autocomplete?: Maybe<CalculatorDefaultPageAutocomplete>;
  cursor?: Maybe<Scalars['String']>;
  facets?: Maybe<CalculatorDefaultPageFacet>;
  item?: Maybe<CalculatorDefaultPage>;
  items?: Maybe<Array<Maybe<CalculatorDefaultPage>>>;
  total?: Maybe<Scalars['Int']>;
};


export type CalculatorDefaultPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type CalculatorDefaultPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BottomContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  CalculateText?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ColumnAdditionalCoverText?: InputMaybe<SearchableStringFilterInput>;
  ColumnDefaultCoverText?: InputMaybe<SearchableStringFilterInput>;
  ColumnWeeklyRateText?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DesktopImage?: InputMaybe<ContentModelReferenceWhereInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<StringFilterInput>;
  InfoText?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  LabelAge?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Metadata?: InputMaybe<CalculatorDefaultPageMetadataBlockWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewDescription?: InputMaybe<SearchableStringFilterInput>;
  PreviewImage?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewTitle?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  RowDeathCoverText?: InputMaybe<SearchableStringFilterInput>;
  RowTPDCoverText?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchCategories?: InputMaybe<CategoryModelWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubTitle?: InputMaybe<SearchableStringFilterInput>;
  TableTitle?: InputMaybe<SearchableStringFilterInput>;
  TitleText?: InputMaybe<SearchableStringFilterInput>;
  TopContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CalculatorDefaultPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CalculatorDefaultPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CalculatorDefaultPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type CalculatorFixedPage = IContent & IData & {
  __typename?: 'CalculatorFixedPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  BottomContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  CalculateText?: Maybe<Scalars['String']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Small help text under the cover field */
  CoverHelpText?: Maybe<Scalars['String']>;
  Created?: Maybe<Scalars['Date']>;
  /** Small text under the Death Only Annual Fee Field */
  DOSmallText?: Maybe<Scalars['String']>;
  DOText?: Maybe<Scalars['String']>;
  /** Small text under the Death and TPD Annual Fee Field */
  DTPDSmallText?: Maybe<Scalars['String']>;
  DTPDText?: Maybe<Scalars['String']>;
  DesktopImage?: Maybe<ContentModelReference>;
  /** When checked, this page will not be displayed on the search results page. */
  ExcludeFromSearch?: Maybe<Scalars['Bool']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['String']>;
  /** Text at the bottom of the calculation result table */
  InfoText?: Maybe<Scalars['String']>;
  IsCommonDraft?: Maybe<Scalars['Bool']>;
  LabelAge?: Maybe<Scalars['String']>;
  LabelCover?: Maybe<Scalars['String']>;
  LabelGender?: Maybe<Scalars['String']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Metadata?: Maybe<CalculatorFixedPageMetadataBlock>;
  Name?: Maybe<Scalars['String']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Description text that is displayed in preview tiles throughout the site. */
  PreviewDescription?: Maybe<Scalars['String']>;
  /** Overrides the default image on the page to be displayed on preview tiles throughout the site. */
  PreviewImage?: Maybe<ContentModelReference>;
  /** Overrides the default title/name on the page to be displayed on preview tiles throughout the site. */
  PreviewTitle?: Maybe<Scalars['String']>;
  RelativePath?: Maybe<Scalars['String']>;
  RouteSegment?: Maybe<Scalars['String']>;
  Saved?: Maybe<Scalars['Date']>;
  SearchCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Shortcut?: Maybe<Scalars['String']>;
  SimpleAddress?: Maybe<Scalars['String']>;
  SiteId?: Maybe<Scalars['String']>;
  StartPublish?: Maybe<Scalars['Date']>;
  Status?: Maybe<Scalars['String']>;
  StopPublish?: Maybe<Scalars['Date']>;
  SubTitle?: Maybe<Scalars['String']>;
  TableTitle?: Maybe<Scalars['String']>;
  TitleText?: Maybe<Scalars['String']>;
  TopContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Url?: Maybe<Scalars['String']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _sortOrder?: Maybe<Scalars['Int']>;
  _track?: Maybe<Scalars['String']>;
};


export type CalculatorFixedPageBottomContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorFixedPageCalculateTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorFixedPageCoverHelpTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorFixedPageDoSmallTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorFixedPageDoTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorFixedPageDtpdSmallTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorFixedPageDtpdTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorFixedPageInfoTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorFixedPageLabelAgeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorFixedPageLabelCoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorFixedPageLabelGenderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorFixedPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorFixedPagePreviewDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorFixedPagePreviewTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorFixedPageSubTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorFixedPageTableTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorFixedPageTitleTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorFixedPageTopContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorFixedPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorFixedPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CalculatorFixedPageAutocomplete = {
  __typename?: 'CalculatorFixedPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  DesktopImage?: Maybe<ContentModelReferenceAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FileSize?: Maybe<Array<Maybe<Scalars['String']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  Metadata?: Maybe<CalculatorFixedPageMetadataBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PreviewImage?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']>>>;
  SearchCategories?: Maybe<CategoryModelAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CalculatorFixedPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorFixedPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorFixedPageAutocompleteFileSizeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorFixedPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorFixedPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorFixedPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorFixedPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorFixedPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorFixedPageAutocompleteStatusArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorFixedPageAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorFixedPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type CalculatorFixedPageFacet = {
  __typename?: 'CalculatorFixedPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BottomContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  CalculateText?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CoverHelpText?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DOSmallText?: Maybe<Array<Maybe<StringFacet>>>;
  DOText?: Maybe<Array<Maybe<StringFacet>>>;
  DTPDSmallText?: Maybe<Array<Maybe<StringFacet>>>;
  DTPDText?: Maybe<Array<Maybe<StringFacet>>>;
  DesktopImage?: Maybe<ContentModelReferenceFacet>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<StringFacet>>>;
  InfoText?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  LabelAge?: Maybe<Array<Maybe<StringFacet>>>;
  LabelCover?: Maybe<Array<Maybe<StringFacet>>>;
  LabelGender?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Metadata?: Maybe<CalculatorFixedPageMetadataBlockFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreviewDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PreviewImage?: Maybe<ContentModelReferenceFacet>;
  PreviewTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchCategories?: Maybe<CategoryModelFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubTitle?: Maybe<Array<Maybe<StringFacet>>>;
  TableTitle?: Maybe<Array<Maybe<StringFacet>>>;
  TitleText?: Maybe<Array<Maybe<StringFacet>>>;
  TopContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CalculatorFixedPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetCalculateTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type CalculatorFixedPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetCoverHelpTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type CalculatorFixedPageFacetDoSmallTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetDoTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetDtpdSmallTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetDtpdTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetInfoTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetLabelAgeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetLabelCoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetLabelGenderArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetPreviewDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetPreviewTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type CalculatorFixedPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type CalculatorFixedPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type CalculatorFixedPageFacetSubTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetTableTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetTitleTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CalculatorFixedPageMetadataBlock = {
  __typename?: 'CalculatorFixedPageMetadataBlock';
  Description?: Maybe<Scalars['String']>;
  Image?: Maybe<ContentModelReference>;
  NoFollow?: Maybe<Scalars['Bool']>;
  NoIndex?: Maybe<Scalars['Bool']>;
  Title?: Maybe<Scalars['String']>;
};


export type CalculatorFixedPageMetadataBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorFixedPageMetadataBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CalculatorFixedPageMetadataBlockAutocomplete = {
  __typename?: 'CalculatorFixedPageMetadataBlockAutocomplete';
  Image?: Maybe<ContentModelReferenceAutocomplete>;
};

export type CalculatorFixedPageMetadataBlockFacet = {
  __typename?: 'CalculatorFixedPageMetadataBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  NoFollow?: Maybe<Array<Maybe<StringFacet>>>;
  NoIndex?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CalculatorFixedPageMetadataBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageMetadataBlockFacetNoFollowArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageMetadataBlockFacetNoIndexArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorFixedPageMetadataBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorFixedPageMetadataBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  NoFollow?: InputMaybe<OrderBy>;
  NoIndex?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type CalculatorFixedPageMetadataBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  NoFollow?: InputMaybe<BoolFilterInput>;
  NoIndex?: InputMaybe<BoolFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type CalculatorFixedPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BottomContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  CalculateText?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CoverHelpText?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DOSmallText?: InputMaybe<OrderBy>;
  DOText?: InputMaybe<OrderBy>;
  DTPDSmallText?: InputMaybe<OrderBy>;
  DTPDText?: InputMaybe<OrderBy>;
  DesktopImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  InfoText?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  LabelAge?: InputMaybe<OrderBy>;
  LabelCover?: InputMaybe<OrderBy>;
  LabelGender?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Metadata?: InputMaybe<CalculatorFixedPageMetadataBlockOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewDescription?: InputMaybe<OrderBy>;
  PreviewImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewTitle?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchCategories?: InputMaybe<CategoryModelOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubTitle?: InputMaybe<OrderBy>;
  TableTitle?: InputMaybe<OrderBy>;
  TitleText?: InputMaybe<OrderBy>;
  TopContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CalculatorFixedPageOutput = {
  __typename?: 'CalculatorFixedPageOutput';
  autocomplete?: Maybe<CalculatorFixedPageAutocomplete>;
  cursor?: Maybe<Scalars['String']>;
  facets?: Maybe<CalculatorFixedPageFacet>;
  item?: Maybe<CalculatorFixedPage>;
  items?: Maybe<Array<Maybe<CalculatorFixedPage>>>;
  total?: Maybe<Scalars['Int']>;
};


export type CalculatorFixedPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type CalculatorFixedPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BottomContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  CalculateText?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CoverHelpText?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DOSmallText?: InputMaybe<SearchableStringFilterInput>;
  DOText?: InputMaybe<SearchableStringFilterInput>;
  DTPDSmallText?: InputMaybe<SearchableStringFilterInput>;
  DTPDText?: InputMaybe<SearchableStringFilterInput>;
  DesktopImage?: InputMaybe<ContentModelReferenceWhereInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<StringFilterInput>;
  InfoText?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  LabelAge?: InputMaybe<SearchableStringFilterInput>;
  LabelCover?: InputMaybe<SearchableStringFilterInput>;
  LabelGender?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Metadata?: InputMaybe<CalculatorFixedPageMetadataBlockWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewDescription?: InputMaybe<SearchableStringFilterInput>;
  PreviewImage?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewTitle?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchCategories?: InputMaybe<CategoryModelWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubTitle?: InputMaybe<SearchableStringFilterInput>;
  TableTitle?: InputMaybe<SearchableStringFilterInput>;
  TitleText?: InputMaybe<SearchableStringFilterInput>;
  TopContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CalculatorFixedPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CalculatorFixedPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CalculatorFixedPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type CalculatorSalaryContinuancePage = IContent & IData & {
  __typename?: 'CalculatorSalaryContinuancePage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  BottomContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  CalculateText?: Maybe<Scalars['String']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']>;
  Column2yText?: Maybe<Scalars['String']>;
  Column5yText?: Maybe<Scalars['String']>;
  Column60yText?: Maybe<Scalars['String']>;
  Column65yText?: Maybe<Scalars['String']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  Created?: Maybe<Scalars['Date']>;
  DefaultUnit?: Maybe<Scalars['Float']>;
  DesktopImage?: Maybe<ContentModelReference>;
  /** When checked, this page will not be displayed on the search results page. */
  ExcludeFromSearch?: Maybe<Scalars['Bool']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['String']>;
  /** Text at the bottom of the calculation result table */
  InfoText?: Maybe<Scalars['String']>;
  /** Small text under the Insured annual Text field */
  InsuredAnnualDescription?: Maybe<Scalars['String']>;
  InsuredAnnualText?: Maybe<Scalars['String']>;
  /** Small text under the Insured Monthly Text field */
  InsuredMonthlyDescription?: Maybe<Scalars['String']>;
  InsuredMonthlyText?: Maybe<Scalars['String']>;
  IsCommonDraft?: Maybe<Scalars['Bool']>;
  LabelAge?: Maybe<Scalars['String']>;
  LabelGender?: Maybe<Scalars['String']>;
  LabelSalary?: Maybe<Scalars['String']>;
  LabelSalaryInsured?: Maybe<Scalars['String']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MaxInsuredPercentage?: Maybe<Scalars['Float']>;
  Metadata?: Maybe<CalculatorSalaryContinuancePageMetadataBlock>;
  Name?: Maybe<Scalars['String']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Description text that is displayed in preview tiles throughout the site. */
  PreviewDescription?: Maybe<Scalars['String']>;
  /** Overrides the default image on the page to be displayed on preview tiles throughout the site. */
  PreviewImage?: Maybe<ContentModelReference>;
  /** Overrides the default title/name on the page to be displayed on preview tiles throughout the site. */
  PreviewTitle?: Maybe<Scalars['String']>;
  RelativePath?: Maybe<Scalars['String']>;
  RouteSegment?: Maybe<Scalars['String']>;
  Row30dText?: Maybe<Scalars['String']>;
  Row60dText?: Maybe<Scalars['String']>;
  Row90dText?: Maybe<Scalars['String']>;
  RowTitleText?: Maybe<Scalars['String']>;
  Saved?: Maybe<Scalars['Date']>;
  SearchCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Shortcut?: Maybe<Scalars['String']>;
  SimpleAddress?: Maybe<Scalars['String']>;
  SiteId?: Maybe<Scalars['String']>;
  StartPublish?: Maybe<Scalars['Date']>;
  Status?: Maybe<Scalars['String']>;
  StopPublish?: Maybe<Scalars['Date']>;
  SubTitle?: Maybe<Scalars['String']>;
  TableTitle?: Maybe<Scalars['String']>;
  TitleText?: Maybe<Scalars['String']>;
  TopContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Url?: Maybe<Scalars['String']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _sortOrder?: Maybe<Scalars['Int']>;
  _track?: Maybe<Scalars['String']>;
};


export type CalculatorSalaryContinuancePageBottomContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageCalculateTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageColumn2yTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageColumn5yTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageColumn60yTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageColumn65yTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageInfoTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageInsuredAnnualDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageInsuredAnnualTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageInsuredMonthlyDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageInsuredMonthlyTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageLabelAgeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageLabelGenderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageLabelSalaryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageLabelSalaryInsuredArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePagePreviewDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePagePreviewTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageRow30dTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageRow60dTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageRow90dTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageRowTitleTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageSubTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageTableTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageTitleTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageTopContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CalculatorSalaryContinuancePageAutocomplete = {
  __typename?: 'CalculatorSalaryContinuancePageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  DesktopImage?: Maybe<ContentModelReferenceAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FileSize?: Maybe<Array<Maybe<Scalars['String']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  Metadata?: Maybe<CalculatorSalaryContinuancePageMetadataBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PreviewImage?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']>>>;
  SearchCategories?: Maybe<CategoryModelAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CalculatorSalaryContinuancePageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorSalaryContinuancePageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorSalaryContinuancePageAutocompleteFileSizeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorSalaryContinuancePageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorSalaryContinuancePageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorSalaryContinuancePageAutocompleteShortcutArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorSalaryContinuancePageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorSalaryContinuancePageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorSalaryContinuancePageAutocompleteStatusArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorSalaryContinuancePageAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CalculatorSalaryContinuancePageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type CalculatorSalaryContinuancePageFacet = {
  __typename?: 'CalculatorSalaryContinuancePageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BottomContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  CalculateText?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Column2yText?: Maybe<Array<Maybe<StringFacet>>>;
  Column5yText?: Maybe<Array<Maybe<StringFacet>>>;
  Column60yText?: Maybe<Array<Maybe<StringFacet>>>;
  Column65yText?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DefaultUnit?: Maybe<Array<Maybe<NumberFacet>>>;
  DesktopImage?: Maybe<ContentModelReferenceFacet>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<StringFacet>>>;
  InfoText?: Maybe<Array<Maybe<StringFacet>>>;
  InsuredAnnualDescription?: Maybe<Array<Maybe<StringFacet>>>;
  InsuredAnnualText?: Maybe<Array<Maybe<StringFacet>>>;
  InsuredMonthlyDescription?: Maybe<Array<Maybe<StringFacet>>>;
  InsuredMonthlyText?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  LabelAge?: Maybe<Array<Maybe<StringFacet>>>;
  LabelGender?: Maybe<Array<Maybe<StringFacet>>>;
  LabelSalary?: Maybe<Array<Maybe<StringFacet>>>;
  LabelSalaryInsured?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MaxInsuredPercentage?: Maybe<Array<Maybe<NumberFacet>>>;
  Metadata?: Maybe<CalculatorSalaryContinuancePageMetadataBlockFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreviewDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PreviewImage?: Maybe<ContentModelReferenceFacet>;
  PreviewTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Row30dText?: Maybe<Array<Maybe<StringFacet>>>;
  Row60dText?: Maybe<Array<Maybe<StringFacet>>>;
  Row90dText?: Maybe<Array<Maybe<StringFacet>>>;
  RowTitleText?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchCategories?: Maybe<CategoryModelFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubTitle?: Maybe<Array<Maybe<StringFacet>>>;
  TableTitle?: Maybe<Array<Maybe<StringFacet>>>;
  TitleText?: Maybe<Array<Maybe<StringFacet>>>;
  TopContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CalculatorSalaryContinuancePageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetCalculateTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type CalculatorSalaryContinuancePageFacetColumn2yTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetColumn5yTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetColumn60yTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetColumn65yTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type CalculatorSalaryContinuancePageFacetDefaultUnitArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CalculatorSalaryContinuancePageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetInfoTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetInsuredAnnualDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetInsuredAnnualTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetInsuredMonthlyDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetInsuredMonthlyTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetLabelAgeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetLabelGenderArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetLabelSalaryArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetLabelSalaryInsuredArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetMaxInsuredPercentageArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CalculatorSalaryContinuancePageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetPreviewDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetPreviewTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetRow30dTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetRow60dTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetRow90dTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetRowTitleTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type CalculatorSalaryContinuancePageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type CalculatorSalaryContinuancePageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type CalculatorSalaryContinuancePageFacetSubTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetTableTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetTitleTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CalculatorSalaryContinuancePageMetadataBlock = {
  __typename?: 'CalculatorSalaryContinuancePageMetadataBlock';
  Description?: Maybe<Scalars['String']>;
  Image?: Maybe<ContentModelReference>;
  NoFollow?: Maybe<Scalars['Bool']>;
  NoIndex?: Maybe<Scalars['Bool']>;
  Title?: Maybe<Scalars['String']>;
};


export type CalculatorSalaryContinuancePageMetadataBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CalculatorSalaryContinuancePageMetadataBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CalculatorSalaryContinuancePageMetadataBlockAutocomplete = {
  __typename?: 'CalculatorSalaryContinuancePageMetadataBlockAutocomplete';
  Image?: Maybe<ContentModelReferenceAutocomplete>;
};

export type CalculatorSalaryContinuancePageMetadataBlockFacet = {
  __typename?: 'CalculatorSalaryContinuancePageMetadataBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  NoFollow?: Maybe<Array<Maybe<StringFacet>>>;
  NoIndex?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CalculatorSalaryContinuancePageMetadataBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageMetadataBlockFacetNoFollowArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageMetadataBlockFacetNoIndexArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CalculatorSalaryContinuancePageMetadataBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CalculatorSalaryContinuancePageMetadataBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  NoFollow?: InputMaybe<OrderBy>;
  NoIndex?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type CalculatorSalaryContinuancePageMetadataBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  NoFollow?: InputMaybe<BoolFilterInput>;
  NoIndex?: InputMaybe<BoolFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type CalculatorSalaryContinuancePageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BottomContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  CalculateText?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Column2yText?: InputMaybe<OrderBy>;
  Column5yText?: InputMaybe<OrderBy>;
  Column60yText?: InputMaybe<OrderBy>;
  Column65yText?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DefaultUnit?: InputMaybe<OrderBy>;
  DesktopImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  InfoText?: InputMaybe<OrderBy>;
  InsuredAnnualDescription?: InputMaybe<OrderBy>;
  InsuredAnnualText?: InputMaybe<OrderBy>;
  InsuredMonthlyDescription?: InputMaybe<OrderBy>;
  InsuredMonthlyText?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  LabelAge?: InputMaybe<OrderBy>;
  LabelGender?: InputMaybe<OrderBy>;
  LabelSalary?: InputMaybe<OrderBy>;
  LabelSalaryInsured?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MaxInsuredPercentage?: InputMaybe<OrderBy>;
  Metadata?: InputMaybe<CalculatorSalaryContinuancePageMetadataBlockOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewDescription?: InputMaybe<OrderBy>;
  PreviewImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewTitle?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Row30dText?: InputMaybe<OrderBy>;
  Row60dText?: InputMaybe<OrderBy>;
  Row90dText?: InputMaybe<OrderBy>;
  RowTitleText?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchCategories?: InputMaybe<CategoryModelOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubTitle?: InputMaybe<OrderBy>;
  TableTitle?: InputMaybe<OrderBy>;
  TitleText?: InputMaybe<OrderBy>;
  TopContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CalculatorSalaryContinuancePageOutput = {
  __typename?: 'CalculatorSalaryContinuancePageOutput';
  autocomplete?: Maybe<CalculatorSalaryContinuancePageAutocomplete>;
  cursor?: Maybe<Scalars['String']>;
  facets?: Maybe<CalculatorSalaryContinuancePageFacet>;
  item?: Maybe<CalculatorSalaryContinuancePage>;
  items?: Maybe<Array<Maybe<CalculatorSalaryContinuancePage>>>;
  total?: Maybe<Scalars['Int']>;
};


export type CalculatorSalaryContinuancePageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type CalculatorSalaryContinuancePageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BottomContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  CalculateText?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Column2yText?: InputMaybe<SearchableStringFilterInput>;
  Column5yText?: InputMaybe<SearchableStringFilterInput>;
  Column60yText?: InputMaybe<SearchableStringFilterInput>;
  Column65yText?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DefaultUnit?: InputMaybe<FloatFilterInput>;
  DesktopImage?: InputMaybe<ContentModelReferenceWhereInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<StringFilterInput>;
  InfoText?: InputMaybe<SearchableStringFilterInput>;
  InsuredAnnualDescription?: InputMaybe<SearchableStringFilterInput>;
  InsuredAnnualText?: InputMaybe<SearchableStringFilterInput>;
  InsuredMonthlyDescription?: InputMaybe<SearchableStringFilterInput>;
  InsuredMonthlyText?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  LabelAge?: InputMaybe<SearchableStringFilterInput>;
  LabelGender?: InputMaybe<SearchableStringFilterInput>;
  LabelSalary?: InputMaybe<SearchableStringFilterInput>;
  LabelSalaryInsured?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MaxInsuredPercentage?: InputMaybe<FloatFilterInput>;
  Metadata?: InputMaybe<CalculatorSalaryContinuancePageMetadataBlockWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewDescription?: InputMaybe<SearchableStringFilterInput>;
  PreviewImage?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewTitle?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Row30dText?: InputMaybe<SearchableStringFilterInput>;
  Row60dText?: InputMaybe<SearchableStringFilterInput>;
  Row90dText?: InputMaybe<SearchableStringFilterInput>;
  RowTitleText?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchCategories?: InputMaybe<CategoryModelWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubTitle?: InputMaybe<SearchableStringFilterInput>;
  TableTitle?: InputMaybe<SearchableStringFilterInput>;
  TitleText?: InputMaybe<SearchableStringFilterInput>;
  TopContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CalculatorSalaryContinuancePageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CalculatorSalaryContinuancePageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CalculatorSalaryContinuancePageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type CategoryModel = {
  __typename?: 'CategoryModel';
  Description?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['Int']>;
  Name?: Maybe<Scalars['String']>;
};

export type CategoryModelAutocomplete = {
  __typename?: 'CategoryModelAutocomplete';
  Description?: Maybe<Array<Maybe<Scalars['String']>>>;
  Name?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CategoryModelAutocompleteDescriptionArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CategoryModelAutocompleteNameArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type CategoryModelFacet = {
  __typename?: 'CategoryModelFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CategoryModelFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CategoryModelFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CategoryModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CategoryModelOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Id?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
};

export type CategoryModelWhereInput = {
  Description?: InputMaybe<StringFilterInput>;
  Id?: InputMaybe<IntFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
};

export type Content = IContent & IData & {
  __typename?: 'Content';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Changed?: Maybe<Scalars['Date']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  Created?: Maybe<Scalars['Date']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['String']>;
  IsCommonDraft?: Maybe<Scalars['Bool']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']>;
  RouteSegment?: Maybe<Scalars['String']>;
  Saved?: Maybe<Scalars['Date']>;
  SearchCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Shortcut?: Maybe<Scalars['String']>;
  SimpleAddress?: Maybe<Scalars['String']>;
  SiteId?: Maybe<Scalars['String']>;
  StartPublish?: Maybe<Scalars['Date']>;
  Status?: Maybe<Scalars['String']>;
  StopPublish?: Maybe<Scalars['Date']>;
  Url?: Maybe<Scalars['String']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _sortOrder?: Maybe<Scalars['Int']>;
  _track?: Maybe<Scalars['String']>;
};


export type ContentNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type Content_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type Content_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ContentAreaItemModelSearch = {
  __typename?: 'ContentAreaItemModelSearch';
  ContentLink?: Maybe<ContentModelReferenceSearch>;
  DisplayOption?: Maybe<Scalars['String']>;
  InlineBlock?: Maybe<InlineBlockPropertyModelSearch>;
  Tag?: Maybe<Scalars['String']>;
};


export type ContentAreaItemModelSearchContentLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentAreaItemModelSearchDisplayOptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentAreaItemModelSearchInlineBlockArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentAreaItemModelSearchTagArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ContentAreaItemModelSearchFacet = {
  __typename?: 'ContentAreaItemModelSearchFacet';
  ContentLink?: Maybe<ContentModelReferenceSearchFacet>;
  DisplayOption?: Maybe<Array<Maybe<StringFacet>>>;
  InlineBlock?: Maybe<InlineBlockPropertyModelSearchFacet>;
  Tag?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ContentAreaItemModelSearchFacetDisplayOptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentAreaItemModelSearchFacetTagArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentAreaItemModelSearchOrderByInput = {
  ContentLink?: InputMaybe<ContentModelReferenceSearchOrderByInput>;
  DisplayOption?: InputMaybe<OrderBy>;
  InlineBlock?: InputMaybe<InlineBlockPropertyModelSearchOrderByInput>;
  Tag?: InputMaybe<OrderBy>;
};

export type ContentAreaItemModelSearchWhereInput = {
  ContentLink?: InputMaybe<ContentModelReferenceSearchWhereInput>;
  DisplayOption?: InputMaybe<SearchableStringFilterInput>;
  InlineBlock?: InputMaybe<InlineBlockPropertyModelSearchWhereInput>;
  Tag?: InputMaybe<SearchableStringFilterInput>;
};

export type ContentAutocomplete = {
  __typename?: 'ContentAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FileSize?: Maybe<Array<Maybe<Scalars['String']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']>>>;
  SearchCategories?: Maybe<CategoryModelAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ContentAutocompleteAncestorsArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ContentAutocompleteContentTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ContentAutocompleteFileSizeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ContentAutocompleteRelativePathArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ContentAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ContentAutocompleteShortcutArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ContentAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ContentAutocompleteSiteIdArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ContentAutocompleteStatusArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ContentAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ContentAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type ContentFacet = {
  __typename?: 'ContentFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchCategories?: Maybe<CategoryModelFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ContentFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type ContentFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type ContentFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type ContentFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type ContentFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type ContentFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContentLanguageModel = {
  __typename?: 'ContentLanguageModel';
  DisplayName?: Maybe<Scalars['String']>;
  Link?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
};

export type ContentLanguageModelAutocomplete = {
  __typename?: 'ContentLanguageModelAutocomplete';
  DisplayName?: Maybe<Array<Maybe<Scalars['String']>>>;
  Link?: Maybe<Array<Maybe<Scalars['String']>>>;
  Name?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ContentLanguageModelAutocompleteDisplayNameArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ContentLanguageModelAutocompleteLinkArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ContentLanguageModelAutocompleteNameArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type ContentLanguageModelFacet = {
  __typename?: 'ContentLanguageModelFacet';
  DisplayName?: Maybe<Array<Maybe<StringFacet>>>;
  Link?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ContentLanguageModelFacetDisplayNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentLanguageModelFacetLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentLanguageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentLanguageModelOrderByInput = {
  DisplayName?: InputMaybe<OrderBy>;
  Link?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
};

export type ContentLanguageModelSearch = {
  __typename?: 'ContentLanguageModelSearch';
  DisplayName?: Maybe<Scalars['String']>;
  Link?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
};


export type ContentLanguageModelSearchDisplayNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentLanguageModelSearchLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentLanguageModelSearchNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ContentLanguageModelSearchFacet = {
  __typename?: 'ContentLanguageModelSearchFacet';
  DisplayName?: Maybe<Array<Maybe<StringFacet>>>;
  Link?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ContentLanguageModelSearchFacetDisplayNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentLanguageModelSearchFacetLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentLanguageModelSearchFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentLanguageModelSearchOrderByInput = {
  DisplayName?: InputMaybe<OrderBy>;
  Link?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
};

export type ContentLanguageModelSearchWhereInput = {
  DisplayName?: InputMaybe<SearchableStringFilterInput>;
  Link?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
};

export type ContentLanguageModelWhereInput = {
  DisplayName?: InputMaybe<StringFilterInput>;
  Link?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
};

export type ContentModelReference = {
  __typename?: 'ContentModelReference';
  Expanded?: Maybe<IContent>;
  GuidValue?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['Int']>;
  Language?: Maybe<ContentLanguageModel>;
  ProviderName?: Maybe<Scalars['String']>;
  Url?: Maybe<Scalars['String']>;
  WorkId?: Maybe<Scalars['Int']>;
};

export type ContentModelReferenceAutocomplete = {
  __typename?: 'ContentModelReferenceAutocomplete';
  GuidValue?: Maybe<Array<Maybe<Scalars['String']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  ProviderName?: Maybe<Array<Maybe<Scalars['String']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ContentModelReferenceAutocompleteGuidValueArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ContentModelReferenceAutocompleteProviderNameArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ContentModelReferenceAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type ContentModelReferenceFacet = {
  __typename?: 'ContentModelReferenceFacet';
  GuidValue?: Maybe<Array<Maybe<StringFacet>>>;
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  ProviderName?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WorkId?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ContentModelReferenceFacetGuidValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ContentModelReferenceFacetProviderNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceFacetWorkIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContentModelReferenceOrderByInput = {
  GuidValue?: InputMaybe<OrderBy>;
  Id?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  ProviderName?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WorkId?: InputMaybe<OrderBy>;
};

export type ContentModelReferenceSearch = {
  __typename?: 'ContentModelReferenceSearch';
  Expanded?: Maybe<IContent>;
  GuidValue?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['Int']>;
  Language?: Maybe<ContentLanguageModelSearch>;
  ProviderName?: Maybe<Scalars['String']>;
  Url?: Maybe<Scalars['String']>;
  WorkId?: Maybe<Scalars['Int']>;
};


export type ContentModelReferenceSearchExpandedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentModelReferenceSearchLanguageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentModelReferenceSearchProviderNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentModelReferenceSearchUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ContentModelReferenceSearchFacet = {
  __typename?: 'ContentModelReferenceSearchFacet';
  GuidValue?: Maybe<Array<Maybe<StringFacet>>>;
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
  Language?: Maybe<ContentLanguageModelSearchFacet>;
  ProviderName?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WorkId?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ContentModelReferenceSearchFacetGuidValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceSearchFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ContentModelReferenceSearchFacetProviderNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceSearchFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceSearchFacetWorkIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContentModelReferenceSearchOrderByInput = {
  GuidValue?: InputMaybe<OrderBy>;
  Id?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelSearchOrderByInput>;
  ProviderName?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WorkId?: InputMaybe<OrderBy>;
};

export type ContentModelReferenceSearchWhereInput = {
  GuidValue?: InputMaybe<StringFilterInput>;
  Id?: InputMaybe<IntFilterInput>;
  Language?: InputMaybe<ContentLanguageModelSearchWhereInput>;
  ProviderName?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<SearchableStringFilterInput>;
  WorkId?: InputMaybe<IntFilterInput>;
};

export type ContentModelReferenceWhereInput = {
  GuidValue?: InputMaybe<StringFilterInput>;
  Id?: InputMaybe<IntFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  ProviderName?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  WorkId?: InputMaybe<IntFilterInput>;
};

export type ContentOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchCategories?: InputMaybe<CategoryModelOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ContentOutput = {
  __typename?: 'ContentOutput';
  autocomplete?: Maybe<ContentAutocomplete>;
  cursor?: Maybe<Scalars['String']>;
  facets?: Maybe<ContentFacet>;
  item?: Maybe<IContent>;
  items?: Maybe<Array<Maybe<IContent>>>;
  total?: Maybe<Scalars['Int']>;
};


export type ContentOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type ContentRootsModel = {
  __typename?: 'ContentRootsModel';
  ContentAssetsRoot?: Maybe<ContentModelReference>;
  GlobalAssetsRoot?: Maybe<ContentModelReference>;
  RootPage?: Maybe<ContentModelReference>;
  SiteAssetsRoot?: Maybe<ContentModelReference>;
  StartPage?: Maybe<ContentModelReference>;
  WasteBasket?: Maybe<ContentModelReference>;
};

export type ContentRootsModelAutocomplete = {
  __typename?: 'ContentRootsModelAutocomplete';
  ContentAssetsRoot?: Maybe<ContentModelReferenceAutocomplete>;
  GlobalAssetsRoot?: Maybe<ContentModelReferenceAutocomplete>;
  RootPage?: Maybe<ContentModelReferenceAutocomplete>;
  SiteAssetsRoot?: Maybe<ContentModelReferenceAutocomplete>;
  StartPage?: Maybe<ContentModelReferenceAutocomplete>;
  WasteBasket?: Maybe<ContentModelReferenceAutocomplete>;
};

export type ContentRootsModelFacet = {
  __typename?: 'ContentRootsModelFacet';
  ContentAssetsRoot?: Maybe<ContentModelReferenceFacet>;
  GlobalAssetsRoot?: Maybe<ContentModelReferenceFacet>;
  RootPage?: Maybe<ContentModelReferenceFacet>;
  SiteAssetsRoot?: Maybe<ContentModelReferenceFacet>;
  StartPage?: Maybe<ContentModelReferenceFacet>;
  WasteBasket?: Maybe<ContentModelReferenceFacet>;
};

export type ContentRootsModelOrderByInput = {
  ContentAssetsRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  GlobalAssetsRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  RootPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  SiteAssetsRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  StartPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  WasteBasket?: InputMaybe<ContentModelReferenceOrderByInput>;
};

export type ContentRootsModelWhereInput = {
  ContentAssetsRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  GlobalAssetsRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  RootPage?: InputMaybe<ContentModelReferenceWhereInput>;
  SiteAssetsRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  StartPage?: InputMaybe<ContentModelReferenceWhereInput>;
  WasteBasket?: InputMaybe<ContentModelReferenceWhereInput>;
};

export type ContentWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<StringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchCategories?: InputMaybe<CategoryModelWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ContentWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ContentWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ContentWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type Country = IContent & IData & {
  __typename?: 'Country';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  Created?: Maybe<Scalars['Date']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['String']>;
  IsCommonDraft?: Maybe<Scalars['Bool']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']>;
  ParentLink?: Maybe<ContentModelReference>;
  PlaceId?: Maybe<Scalars['String']>;
  RelativePath?: Maybe<Scalars['String']>;
  RouteSegment?: Maybe<Scalars['String']>;
  Saved?: Maybe<Scalars['Date']>;
  SearchCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Shortcut?: Maybe<Scalars['String']>;
  SimpleAddress?: Maybe<Scalars['String']>;
  SiteId?: Maybe<Scalars['String']>;
  StartPublish?: Maybe<Scalars['Date']>;
  Status?: Maybe<Scalars['String']>;
  StopPublish?: Maybe<Scalars['Date']>;
  Url?: Maybe<Scalars['String']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _sortOrder?: Maybe<Scalars['Int']>;
  _track?: Maybe<Scalars['String']>;
};


export type CountryNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CountryPlaceIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type Country_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type Country_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CountryAutocomplete = {
  __typename?: 'CountryAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FileSize?: Maybe<Array<Maybe<Scalars['String']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']>>>;
  SearchCategories?: Maybe<CategoryModelAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CountryAutocompleteAncestorsArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CountryAutocompleteContentTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CountryAutocompleteFileSizeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CountryAutocompleteRelativePathArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CountryAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CountryAutocompleteShortcutArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CountryAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CountryAutocompleteSiteIdArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CountryAutocompleteStatusArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CountryAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type CountryAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type CountryFacet = {
  __typename?: 'CountryFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PlaceId?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchCategories?: Maybe<CategoryModelFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CountryFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CountryFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type CountryFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CountryFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type CountryFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CountryFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CountryFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CountryFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CountryFacetPlaceIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CountryFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CountryFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CountryFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type CountryFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CountryFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CountryFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CountryFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type CountryFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CountryFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type CountryFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CountryFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CountryFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CountryOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PlaceId?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchCategories?: InputMaybe<CategoryModelOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CountryOutput = {
  __typename?: 'CountryOutput';
  autocomplete?: Maybe<CountryAutocomplete>;
  cursor?: Maybe<Scalars['String']>;
  facets?: Maybe<CountryFacet>;
  item?: Maybe<Country>;
  items?: Maybe<Array<Maybe<Country>>>;
  total?: Maybe<Scalars['Int']>;
};


export type CountryOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type CountryWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<StringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PlaceId?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchCategories?: InputMaybe<CategoryModelWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CountryWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CountryWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CountryWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type Data = IData & {
  __typename?: 'Data';
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _track?: Maybe<Scalars['String']>;
};


export type Data_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type Data_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DataOrderByInput = {
  _minimumScore?: InputMaybe<Scalars['Float']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']>;
};

export type DataOutput = {
  __typename?: 'DataOutput';
  cursor?: Maybe<Scalars['String']>;
  item?: Maybe<IData>;
  items?: Maybe<Array<Maybe<IData>>>;
  total?: Maybe<Scalars['Int']>;
};


export type DataOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type DataWhereInput = {
  _and?: InputMaybe<Array<InputMaybe<DataWhereInput>>>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DataWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DataWhereInput>>>;
};

export type DateFacet = {
  __typename?: 'DateFacet';
  count?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export enum DateFacetUnit {
  /** Defined as 24 hours (86,400,000 milliseconds). All days begin at the earliest possible time, which is usually 00:00:00 (midnight). */
  Day = 'DAY',
  /** Defined as 60 minutes each (3,600,000 milliseconds). All hours begin at 00 minutes and 00 seconds. */
  Hour = 'HOUR',
  /** Defined as 1000 milliseconds each. */
  Minute = 'MINUTE'
}

export type DateFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']>;
  /** `decay` influences the weight of the score with a decay function. For example, results that have a more recent datetime will be ranked higher. The `origin` will be `now()` in case not specified. The `scale` is by default 10. The `rate` must be in the range `[0..1]`. */
  decay?: InputMaybe<Decay>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['Date']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']>;
  /** `gt` retrieves results with matches that have a value which is `greater than` it. */
  gt?: InputMaybe<Scalars['Date']>;
  /** `gte` retrieves results with matches that have a value which is `greater than or equal to` it. */
  gte?: InputMaybe<Scalars['Date']>;
  /** `lt` retrieves results with matches that have a value which is `lower than` it. */
  lt?: InputMaybe<Scalars['Date']>;
  /** `lte` retrieves results with matches that have a value which is `lower than or equal to` it. */
  lte?: InputMaybe<Scalars['Date']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['Date']>;
};

/** Decay influences the weight of the score based on field values with a decay function */
export type Decay = {
  origin?: InputMaybe<Scalars['Date']>;
  rate?: InputMaybe<Scalars['Float']>;
  scale?: InputMaybe<Scalars['Int']>;
};

export enum FactorModifier {
  /** Add 1 to the field value and take the natural logarithm */
  Log = 'LOG',
  /** Do not apply any multiplier to the field value */
  None = 'NONE',
  /** Reciprocate the field value, same as 1/x where x is the field's value */
  Reciprocal = 'RECIPROCAL',
  /** Take the square root of the field value */
  Sqrt = 'SQRT',
  /** Square the field value (multiply it by itself) */
  Square = 'SQUARE'
}

export type FloatFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Float']>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['Float']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']>;
  /** `Factor` allows you to use a number value in a field to influence the `_score` directly. If used on a multi-valued field, then only the lowest value of the field is used in calculations. Default for `value` is `1`. Default for `modifier` is `NONE`. */
  factor?: InputMaybe<NumberFactor>;
  /** `gt` retrieves results with matches that have a value which is `greater than` it. */
  gt?: InputMaybe<Scalars['Float']>;
  /** `gte` retrieves results with matches that have a value which is `greater than or equal to` it. */
  gte?: InputMaybe<Scalars['Float']>;
  /** `in` matches with 1 or more exact values in a list. Example: `in: ["word1", "word2", "this is a phrase"]` */
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** `lt` retrieves results with matches that have a value which is `lower than` it. */
  lt?: InputMaybe<Scalars['Float']>;
  /** `lte` retrieves results with matches that have a value which is `lower than or equal to` it. */
  lte?: InputMaybe<Scalars['Float']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['Float']>;
  /** `not_in` returns results that do not match with 1 or more exact values in a list. Example: `not_in: ["word1", "word2", "this is a phrase"]` */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

/** Options for highlighting */
export type HighlightOptions = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  endToken?: InputMaybe<Scalars['String']>;
  startToken?: InputMaybe<Scalars['String']>;
};

/** Landing page that is commonly used for the homepage. */
export type HomePage = IContent & IData & {
  __typename?: 'HomePage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']>;
  ContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  Created?: Maybe<Scalars['Date']>;
  /** When checked, this page will not be displayed on the search results page. */
  ExcludeFromSearch?: Maybe<Scalars['Bool']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['String']>;
  Footer?: Maybe<HomePageFooterBlock>;
  Header?: Maybe<HomePageHeaderBlock>;
  IsCommonDraft?: Maybe<Scalars['Bool']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Metadata?: Maybe<HomePageMetadataBlock>;
  Name?: Maybe<Scalars['String']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Description text that is displayed in preview tiles throughout the site. */
  PreviewDescription?: Maybe<Scalars['String']>;
  /** Overrides the default image on the page to be displayed on preview tiles throughout the site. */
  PreviewImage?: Maybe<ContentModelReference>;
  /** Overrides the default title/name on the page to be displayed on preview tiles throughout the site. */
  PreviewTitle?: Maybe<Scalars['String']>;
  RelativePath?: Maybe<Scalars['String']>;
  RouteSegment?: Maybe<Scalars['String']>;
  Saved?: Maybe<Scalars['Date']>;
  SearchCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Shortcut?: Maybe<Scalars['String']>;
  SimpleAddress?: Maybe<Scalars['String']>;
  SiteId?: Maybe<Scalars['String']>;
  StartPublish?: Maybe<Scalars['Date']>;
  Status?: Maybe<Scalars['String']>;
  StopPublish?: Maybe<Scalars['Date']>;
  Url?: Maybe<Scalars['String']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _sortOrder?: Maybe<Scalars['Int']>;
  _track?: Maybe<Scalars['String']>;
};


/** Landing page that is commonly used for the homepage. */
export type HomePageContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Landing page that is commonly used for the homepage. */
export type HomePageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Landing page that is commonly used for the homepage. */
export type HomePagePreviewDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Landing page that is commonly used for the homepage. */
export type HomePagePreviewTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Landing page that is commonly used for the homepage. */
export type HomePage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Landing page that is commonly used for the homepage. */
export type HomePage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type HomePageAutocomplete = {
  __typename?: 'HomePageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FileSize?: Maybe<Array<Maybe<Scalars['String']>>>;
  Footer?: Maybe<HomePageFooterBlockAutocomplete>;
  Header?: Maybe<HomePageHeaderBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  Metadata?: Maybe<HomePageMetadataBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PreviewImage?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']>>>;
  SearchCategories?: Maybe<CategoryModelAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type HomePageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type HomePageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type HomePageAutocompleteFileSizeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type HomePageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type HomePageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type HomePageAutocompleteShortcutArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type HomePageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type HomePageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type HomePageAutocompleteStatusArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type HomePageAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type HomePageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type HomePageFacet = {
  __typename?: 'HomePageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<StringFacet>>>;
  Footer?: Maybe<HomePageFooterBlockFacet>;
  Header?: Maybe<HomePageHeaderBlockFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Metadata?: Maybe<HomePageMetadataBlockFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreviewDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PreviewImage?: Maybe<ContentModelReferenceFacet>;
  PreviewTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchCategories?: Maybe<CategoryModelFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type HomePageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type HomePageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type HomePageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetPreviewDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetPreviewTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type HomePageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type HomePageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type HomePageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type HomePageFooterBlock = {
  __typename?: 'HomePageFooterBlock';
  AppStoreLink?: Maybe<Scalars['String']>;
  AppStoreLogo?: Maybe<ContentModelReference>;
  CopyrightText?: Maybe<Scalars['String']>;
  Disclaimer?: Maybe<Scalars['String']>;
  FacebookLink?: Maybe<Scalars['String']>;
  GoogleAppLink?: Maybe<Scalars['String']>;
  GoogleAppLogo?: Maybe<ContentModelReference>;
  HideFooter?: Maybe<Scalars['Bool']>;
  InstagramLink?: Maybe<Scalars['String']>;
  IntroductionText?: Maybe<Scalars['String']>;
  LinkLists?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  LinkedInLink?: Maybe<Scalars['String']>;
  Logo?: Maybe<ContentModelReference>;
  LogoHeight?: Maybe<Scalars['Int']>;
  LogoWidth?: Maybe<Scalars['Int']>;
  TwitterLink?: Maybe<Scalars['String']>;
  YoutubeLink?: Maybe<Scalars['String']>;
};


export type HomePageFooterBlockAppStoreLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageFooterBlockCopyrightTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageFooterBlockDisclaimerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageFooterBlockFacebookLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageFooterBlockGoogleAppLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageFooterBlockInstagramLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageFooterBlockIntroductionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageFooterBlockLinkListsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageFooterBlockLinkedInLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageFooterBlockTwitterLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageFooterBlockYoutubeLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HomePageFooterBlockAutocomplete = {
  __typename?: 'HomePageFooterBlockAutocomplete';
  AppStoreLogo?: Maybe<ContentModelReferenceAutocomplete>;
  GoogleAppLogo?: Maybe<ContentModelReferenceAutocomplete>;
  Logo?: Maybe<ContentModelReferenceAutocomplete>;
};

export type HomePageFooterBlockFacet = {
  __typename?: 'HomePageFooterBlockFacet';
  AppStoreLink?: Maybe<Array<Maybe<StringFacet>>>;
  AppStoreLogo?: Maybe<ContentModelReferenceFacet>;
  CopyrightText?: Maybe<Array<Maybe<StringFacet>>>;
  Disclaimer?: Maybe<Array<Maybe<StringFacet>>>;
  FacebookLink?: Maybe<Array<Maybe<StringFacet>>>;
  GoogleAppLink?: Maybe<Array<Maybe<StringFacet>>>;
  GoogleAppLogo?: Maybe<ContentModelReferenceFacet>;
  HideFooter?: Maybe<Array<Maybe<StringFacet>>>;
  InstagramLink?: Maybe<Array<Maybe<StringFacet>>>;
  IntroductionText?: Maybe<Array<Maybe<StringFacet>>>;
  LinkLists?: Maybe<ContentAreaItemModelSearchFacet>;
  LinkedInLink?: Maybe<Array<Maybe<StringFacet>>>;
  Logo?: Maybe<ContentModelReferenceFacet>;
  LogoHeight?: Maybe<Array<Maybe<NumberFacet>>>;
  LogoWidth?: Maybe<Array<Maybe<NumberFacet>>>;
  TwitterLink?: Maybe<Array<Maybe<StringFacet>>>;
  YoutubeLink?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HomePageFooterBlockFacetAppStoreLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFooterBlockFacetCopyrightTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFooterBlockFacetDisclaimerArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFooterBlockFacetFacebookLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFooterBlockFacetGoogleAppLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFooterBlockFacetHideFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFooterBlockFacetInstagramLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFooterBlockFacetIntroductionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFooterBlockFacetLinkedInLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFooterBlockFacetLogoHeightArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type HomePageFooterBlockFacetLogoWidthArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type HomePageFooterBlockFacetTwitterLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFooterBlockFacetYoutubeLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomePageFooterBlockOrderByInput = {
  AppStoreLink?: InputMaybe<OrderBy>;
  AppStoreLogo?: InputMaybe<ContentModelReferenceOrderByInput>;
  CopyrightText?: InputMaybe<OrderBy>;
  Disclaimer?: InputMaybe<OrderBy>;
  FacebookLink?: InputMaybe<OrderBy>;
  GoogleAppLink?: InputMaybe<OrderBy>;
  GoogleAppLogo?: InputMaybe<ContentModelReferenceOrderByInput>;
  HideFooter?: InputMaybe<OrderBy>;
  InstagramLink?: InputMaybe<OrderBy>;
  IntroductionText?: InputMaybe<OrderBy>;
  LinkLists?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  LinkedInLink?: InputMaybe<OrderBy>;
  Logo?: InputMaybe<ContentModelReferenceOrderByInput>;
  LogoHeight?: InputMaybe<OrderBy>;
  LogoWidth?: InputMaybe<OrderBy>;
  TwitterLink?: InputMaybe<OrderBy>;
  YoutubeLink?: InputMaybe<OrderBy>;
};

export type HomePageFooterBlockWhereInput = {
  AppStoreLink?: InputMaybe<SearchableStringFilterInput>;
  AppStoreLogo?: InputMaybe<ContentModelReferenceWhereInput>;
  CopyrightText?: InputMaybe<SearchableStringFilterInput>;
  Disclaimer?: InputMaybe<SearchableStringFilterInput>;
  FacebookLink?: InputMaybe<SearchableStringFilterInput>;
  GoogleAppLink?: InputMaybe<SearchableStringFilterInput>;
  GoogleAppLogo?: InputMaybe<ContentModelReferenceWhereInput>;
  HideFooter?: InputMaybe<BoolFilterInput>;
  InstagramLink?: InputMaybe<SearchableStringFilterInput>;
  IntroductionText?: InputMaybe<SearchableStringFilterInput>;
  LinkLists?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  LinkedInLink?: InputMaybe<SearchableStringFilterInput>;
  Logo?: InputMaybe<ContentModelReferenceWhereInput>;
  LogoHeight?: InputMaybe<IntFilterInput>;
  LogoWidth?: InputMaybe<IntFilterInput>;
  TwitterLink?: InputMaybe<SearchableStringFilterInput>;
  YoutubeLink?: InputMaybe<SearchableStringFilterInput>;
};

export type HomePageHeaderBlock = {
  __typename?: 'HomePageHeaderBlock';
  Logo?: Maybe<ContentModelReference>;
  LogoHeight?: Maybe<Scalars['Int']>;
  LogoWidth?: Maybe<Scalars['Int']>;
  MenuItems?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MobileLogo?: Maybe<ContentModelReference>;
  SearchPage?: Maybe<ContentModelReference>;
  SearchPlaceholderText?: Maybe<Scalars['String']>;
  TopMenuLinks?: Maybe<Array<Maybe<LinkItemNode>>>;
};


export type HomePageHeaderBlockMenuItemsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageHeaderBlockSearchPlaceholderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HomePageHeaderBlockAutocomplete = {
  __typename?: 'HomePageHeaderBlockAutocomplete';
  Logo?: Maybe<ContentModelReferenceAutocomplete>;
  MobileLogo?: Maybe<ContentModelReferenceAutocomplete>;
  SearchPage?: Maybe<ContentModelReferenceAutocomplete>;
  TopMenuLinks?: Maybe<LinkItemNodeAutocomplete>;
};

export type HomePageHeaderBlockFacet = {
  __typename?: 'HomePageHeaderBlockFacet';
  Logo?: Maybe<ContentModelReferenceFacet>;
  LogoHeight?: Maybe<Array<Maybe<NumberFacet>>>;
  LogoWidth?: Maybe<Array<Maybe<NumberFacet>>>;
  MenuItems?: Maybe<ContentAreaItemModelSearchFacet>;
  MobileLogo?: Maybe<ContentModelReferenceFacet>;
  SearchPage?: Maybe<ContentModelReferenceFacet>;
  SearchPlaceholderText?: Maybe<Array<Maybe<StringFacet>>>;
  TopMenuLinks?: Maybe<LinkItemNodeFacet>;
};


export type HomePageHeaderBlockFacetLogoHeightArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type HomePageHeaderBlockFacetLogoWidthArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type HomePageHeaderBlockFacetSearchPlaceholderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomePageHeaderBlockOrderByInput = {
  Logo?: InputMaybe<ContentModelReferenceOrderByInput>;
  LogoHeight?: InputMaybe<OrderBy>;
  LogoWidth?: InputMaybe<OrderBy>;
  MenuItems?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MobileLogo?: InputMaybe<ContentModelReferenceOrderByInput>;
  SearchPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  SearchPlaceholderText?: InputMaybe<OrderBy>;
  TopMenuLinks?: InputMaybe<LinkItemNodeOrderByInput>;
};

export type HomePageHeaderBlockWhereInput = {
  Logo?: InputMaybe<ContentModelReferenceWhereInput>;
  LogoHeight?: InputMaybe<IntFilterInput>;
  LogoWidth?: InputMaybe<IntFilterInput>;
  MenuItems?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MobileLogo?: InputMaybe<ContentModelReferenceWhereInput>;
  SearchPage?: InputMaybe<ContentModelReferenceWhereInput>;
  SearchPlaceholderText?: InputMaybe<SearchableStringFilterInput>;
  TopMenuLinks?: InputMaybe<LinkItemNodeWhereInput>;
};

export type HomePageMetadataBlock = {
  __typename?: 'HomePageMetadataBlock';
  Description?: Maybe<Scalars['String']>;
  Image?: Maybe<ContentModelReference>;
  NoFollow?: Maybe<Scalars['Bool']>;
  NoIndex?: Maybe<Scalars['Bool']>;
  Title?: Maybe<Scalars['String']>;
};


export type HomePageMetadataBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageMetadataBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HomePageMetadataBlockAutocomplete = {
  __typename?: 'HomePageMetadataBlockAutocomplete';
  Image?: Maybe<ContentModelReferenceAutocomplete>;
};

export type HomePageMetadataBlockFacet = {
  __typename?: 'HomePageMetadataBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  NoFollow?: Maybe<Array<Maybe<StringFacet>>>;
  NoIndex?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HomePageMetadataBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageMetadataBlockFacetNoFollowArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageMetadataBlockFacetNoIndexArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageMetadataBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomePageMetadataBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  NoFollow?: InputMaybe<OrderBy>;
  NoIndex?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type HomePageMetadataBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  NoFollow?: InputMaybe<BoolFilterInput>;
  NoIndex?: InputMaybe<BoolFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type HomePageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  Footer?: InputMaybe<HomePageFooterBlockOrderByInput>;
  Header?: InputMaybe<HomePageHeaderBlockOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Metadata?: InputMaybe<HomePageMetadataBlockOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewDescription?: InputMaybe<OrderBy>;
  PreviewImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewTitle?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchCategories?: InputMaybe<CategoryModelOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type HomePageOutput = {
  __typename?: 'HomePageOutput';
  autocomplete?: Maybe<HomePageAutocomplete>;
  cursor?: Maybe<Scalars['String']>;
  facets?: Maybe<HomePageFacet>;
  item?: Maybe<HomePage>;
  items?: Maybe<Array<Maybe<HomePage>>>;
  total?: Maybe<Scalars['Int']>;
};


export type HomePageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type HomePageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<StringFilterInput>;
  Footer?: InputMaybe<HomePageFooterBlockWhereInput>;
  Header?: InputMaybe<HomePageHeaderBlockWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Metadata?: InputMaybe<HomePageMetadataBlockWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewDescription?: InputMaybe<SearchableStringFilterInput>;
  PreviewImage?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewTitle?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchCategories?: InputMaybe<CategoryModelWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<HomePageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<HomePageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<HomePageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type HostDefinitionModel = {
  __typename?: 'HostDefinitionModel';
  Language?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['String']>;
};

export type HostDefinitionModelAutocomplete = {
  __typename?: 'HostDefinitionModelAutocomplete';
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  Name?: Maybe<Array<Maybe<Scalars['String']>>>;
  Type?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type HostDefinitionModelAutocompleteNameArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type HostDefinitionModelAutocompleteTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type HostDefinitionModelFacet = {
  __typename?: 'HostDefinitionModelFacet';
  Language?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  Type?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HostDefinitionModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HostDefinitionModelFacetTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HostDefinitionModelOrderByInput = {
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  Type?: InputMaybe<OrderBy>;
};

export type HostDefinitionModelWhereInput = {
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<StringFilterInput>;
  Type?: InputMaybe<StringFilterInput>;
};

export type IContent = {
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Changed?: Maybe<Scalars['Date']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  Created?: Maybe<Scalars['Date']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['String']>;
  IsCommonDraft?: Maybe<Scalars['Bool']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']>;
  RouteSegment?: Maybe<Scalars['String']>;
  Saved?: Maybe<Scalars['Date']>;
  SearchCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Shortcut?: Maybe<Scalars['String']>;
  SimpleAddress?: Maybe<Scalars['String']>;
  SiteId?: Maybe<Scalars['String']>;
  StartPublish?: Maybe<Scalars['Date']>;
  Status?: Maybe<Scalars['String']>;
  StopPublish?: Maybe<Scalars['Date']>;
  Url?: Maybe<Scalars['String']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _sortOrder?: Maybe<Scalars['Int']>;
  _track?: Maybe<Scalars['String']>;
};


export type IContentNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IContent_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IContent_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IData = {
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _track?: Maybe<Scalars['String']>;
};


export type IData_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IData_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ImageFile = IContent & IData & {
  __typename?: 'ImageFile';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']>;
  Content?: Maybe<Scalars['String']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  Created?: Maybe<Scalars['Date']>;
  /** Used as alt tag. Name will be used when empty */
  Description?: Maybe<Scalars['String']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileExtension?: Maybe<Scalars['String']>;
  FileSize?: Maybe<Scalars['String']>;
  Height?: Maybe<Scalars['Int']>;
  IsCommonDraft?: Maybe<Scalars['Bool']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MimeType?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']>;
  RouteSegment?: Maybe<Scalars['String']>;
  Saved?: Maybe<Scalars['Date']>;
  SearchCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Shortcut?: Maybe<Scalars['String']>;
  SimpleAddress?: Maybe<Scalars['String']>;
  SiteId?: Maybe<Scalars['String']>;
  StartPublish?: Maybe<Scalars['Date']>;
  Status?: Maybe<Scalars['String']>;
  StopPublish?: Maybe<Scalars['Date']>;
  Thumbnail?: Maybe<BlobModel>;
  /** Used for title tag. Name will be used when empty */
  Title?: Maybe<Scalars['String']>;
  Url?: Maybe<Scalars['String']>;
  Width?: Maybe<Scalars['Int']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _sortOrder?: Maybe<Scalars['Int']>;
  _track?: Maybe<Scalars['String']>;
};


export type ImageFileContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageFileDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageFileFileExtensionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageFileTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageFile_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageFile_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ImageFileAutocomplete = {
  __typename?: 'ImageFileAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FileSize?: Maybe<Array<Maybe<Scalars['String']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']>>>;
  SearchCategories?: Maybe<CategoryModelAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ImageFileAutocompleteAncestorsArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ImageFileAutocompleteContentTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ImageFileAutocompleteFileSizeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ImageFileAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ImageFileAutocompleteRelativePathArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ImageFileAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ImageFileAutocompleteShortcutArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ImageFileAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ImageFileAutocompleteSiteIdArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ImageFileAutocompleteStatusArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ImageFileAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type ImageFileAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type ImageFileFacet = {
  __typename?: 'ImageFileFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileExtension?: Maybe<Array<Maybe<StringFacet>>>;
  FileSize?: Maybe<Array<Maybe<StringFacet>>>;
  Height?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchCategories?: Maybe<CategoryModelFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Width?: Maybe<Array<Maybe<NumberFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ImageFileFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFileFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type ImageFileFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFileFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFileFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type ImageFileFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFileFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFileFacetFileExtensionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFileFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFileFacetHeightArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ImageFileFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFileFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFileFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFileFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFileFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFileFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type ImageFileFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFileFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFileFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFileFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type ImageFileFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFileFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type ImageFileFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFileFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFileFacetWidthArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ImageFileFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFileFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ImageFileOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileExtension?: InputMaybe<OrderBy>;
  FileSize?: InputMaybe<OrderBy>;
  Height?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchCategories?: InputMaybe<CategoryModelOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Width?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ImageFileOutput = {
  __typename?: 'ImageFileOutput';
  autocomplete?: Maybe<ImageFileAutocomplete>;
  cursor?: Maybe<Scalars['String']>;
  facets?: Maybe<ImageFileFacet>;
  item?: Maybe<ImageFile>;
  items?: Maybe<Array<Maybe<ImageFile>>>;
  total?: Maybe<Scalars['Int']>;
};


export type ImageFileOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type ImageFileWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileExtension?: InputMaybe<SearchableStringFilterInput>;
  FileSize?: InputMaybe<StringFilterInput>;
  Height?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchCategories?: InputMaybe<CategoryModelWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Width?: InputMaybe<IntFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ImageFileWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ImageFileWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ImageFileWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type InlineBlockPropertyModelSearch = {
  __typename?: 'InlineBlockPropertyModelSearch';
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type InlineBlockPropertyModelSearchContentTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type InlineBlockPropertyModelSearchFacet = {
  __typename?: 'InlineBlockPropertyModelSearchFacet';
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type InlineBlockPropertyModelSearchFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InlineBlockPropertyModelSearchOrderByInput = {
  ContentType?: InputMaybe<OrderBy>;
};

export type InlineBlockPropertyModelSearchWhereInput = {
  ContentType?: InputMaybe<SearchableStringFilterInput>;
};

export type IntFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['Int']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']>;
  /** `Factor` allows you to use a number value in a field to influence the `_score` directly. If used on a multi-valued field, then only the lowest value of the field is used in calculations. Default for `value` is `1`. Default for `modifier` is `NONE`. */
  factor?: InputMaybe<NumberFactor>;
  /** `gt` retrieves results with matches that have a value which is `greater than` it. */
  gt?: InputMaybe<Scalars['Int']>;
  /** `gte` retrieves results with matches that have a value which is `greater than or equal to` it. */
  gte?: InputMaybe<Scalars['Int']>;
  /** `in` matches with 1 or more exact values in a list. Example: `in: ["word1", "word2", "this is a phrase"]` */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** `lt` retrieves results with matches that have a value which is `lower than` it. */
  lt?: InputMaybe<Scalars['Int']>;
  /** `lte` retrieves results with matches that have a value which is `lower than or equal to` it. */
  lte?: InputMaybe<Scalars['Int']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['Int']>;
  /** `not_in` returns results that do not match with 1 or more exact values in a list. Example: `not_in: ["word1", "word2", "this is a phrase"]` */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type LinkConfig = {
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

export type LinkItemNode = {
  __typename?: 'LinkItemNode';
  ContentLink?: Maybe<ContentModelReference>;
  Href?: Maybe<Scalars['String']>;
  Target?: Maybe<Scalars['String']>;
  Text?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
};

export type LinkItemNodeAutocomplete = {
  __typename?: 'LinkItemNodeAutocomplete';
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  Href?: Maybe<Array<Maybe<Scalars['String']>>>;
  Target?: Maybe<Array<Maybe<Scalars['String']>>>;
  Text?: Maybe<Array<Maybe<Scalars['String']>>>;
  Title?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type LinkItemNodeAutocompleteHrefArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type LinkItemNodeAutocompleteTargetArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type LinkItemNodeAutocompleteTextArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type LinkItemNodeAutocompleteTitleArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type LinkItemNodeFacet = {
  __typename?: 'LinkItemNodeFacet';
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  Href?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
  Text?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type LinkItemNodeFacetHrefArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkItemNodeFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkItemNodeFacetTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkItemNodeFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LinkItemNodeOrderByInput = {
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Href?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
  Text?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type LinkItemNodeWhereInput = {
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Href?: InputMaybe<StringFilterInput>;
  Target?: InputMaybe<StringFilterInput>;
  Text?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
};

export enum LinkTypes {
  /**
   *
   * | *Direction* | &nbsp; | *Field*     |
   * | ----------: | ------ | :---------- |
   * | *from*      |        | `Ancestors` |
   * | *to*        |        | `ContentLink.GuidValue`   |
   */
  Ancestors = 'ANCESTORS',
  /**
   *
   * | *Direction* | &nbsp; | *Field*     |
   * | ----------: | ------ | :---------- |
   * | *from*      |        | `ContentLink.GuidValue` |
   * | *to*        |        | `ParentLink.GuidValue`   |
   */
  Children = 'CHILDREN',
  /**
   *
   * | *Direction* | &nbsp; | *Field*     |
   * | ----------: | ------ | :---------- |
   * | *from*      |        | `ContentLink.GuidValue` |
   * | *to*        |        | `ParentLink.GuidValue`   |
   */
  Default = 'DEFAULT'
}

export enum Locales {
  All = 'ALL',
  Neutral = 'NEUTRAL',
  EnAu = 'en_AU'
}

export type LocationListingPage = IContent & IData & {
  __typename?: 'LocationListingPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  BottomContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  Created?: Maybe<Scalars['Date']>;
  /** When checked, this page will not be displayed on the search results page. */
  ExcludeFromSearch?: Maybe<Scalars['Bool']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['String']>;
  IsCommonDraft?: Maybe<Scalars['Bool']>;
  ItemsPerPage?: Maybe<Scalars['Int']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Metadata?: Maybe<LocationListingPageMetadataBlock>;
  Name?: Maybe<Scalars['String']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Description text that is displayed in preview tiles throughout the site. */
  PreviewDescription?: Maybe<Scalars['String']>;
  /** Overrides the default image on the page to be displayed on preview tiles throughout the site. */
  PreviewImage?: Maybe<ContentModelReference>;
  /** Overrides the default title/name on the page to be displayed on preview tiles throughout the site. */
  PreviewTitle?: Maybe<Scalars['String']>;
  RelativePath?: Maybe<Scalars['String']>;
  RouteSegment?: Maybe<Scalars['String']>;
  Saved?: Maybe<Scalars['Date']>;
  SearchCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Shortcut?: Maybe<Scalars['String']>;
  SimpleAddress?: Maybe<Scalars['String']>;
  SiteId?: Maybe<Scalars['String']>;
  StartPublish?: Maybe<Scalars['Date']>;
  Status?: Maybe<Scalars['String']>;
  StopPublish?: Maybe<Scalars['Date']>;
  Title?: Maybe<Scalars['String']>;
  TopContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Url?: Maybe<Scalars['String']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _sortOrder?: Maybe<Scalars['Int']>;
  _track?: Maybe<Scalars['String']>;
};


export type LocationListingPageBottomContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationListingPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationListingPagePreviewDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationListingPagePreviewTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationListingPageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationListingPageTopContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationListingPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationListingPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LocationListingPageAutocomplete = {
  __typename?: 'LocationListingPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FileSize?: Maybe<Array<Maybe<Scalars['String']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  Metadata?: Maybe<LocationListingPageMetadataBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PreviewImage?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']>>>;
  SearchCategories?: Maybe<CategoryModelAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type LocationListingPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type LocationListingPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type LocationListingPageAutocompleteFileSizeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type LocationListingPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type LocationListingPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type LocationListingPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type LocationListingPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type LocationListingPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type LocationListingPageAutocompleteStatusArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type LocationListingPageAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type LocationListingPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type LocationListingPageFacet = {
  __typename?: 'LocationListingPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BottomContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  ItemsPerPage?: Maybe<Array<Maybe<NumberFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Metadata?: Maybe<LocationListingPageMetadataBlockFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreviewDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PreviewImage?: Maybe<ContentModelReferenceFacet>;
  PreviewTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchCategories?: Maybe<CategoryModelFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TopContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type LocationListingPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationListingPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type LocationListingPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationListingPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type LocationListingPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationListingPageFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationListingPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationListingPageFacetItemsPerPageArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LocationListingPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationListingPageFacetPreviewDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationListingPageFacetPreviewTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationListingPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationListingPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationListingPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type LocationListingPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationListingPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationListingPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationListingPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type LocationListingPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationListingPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type LocationListingPageFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationListingPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationListingPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationListingPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LocationListingPageMetadataBlock = {
  __typename?: 'LocationListingPageMetadataBlock';
  Description?: Maybe<Scalars['String']>;
  Image?: Maybe<ContentModelReference>;
  NoFollow?: Maybe<Scalars['Bool']>;
  NoIndex?: Maybe<Scalars['Bool']>;
  Title?: Maybe<Scalars['String']>;
};


export type LocationListingPageMetadataBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationListingPageMetadataBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type LocationListingPageMetadataBlockAutocomplete = {
  __typename?: 'LocationListingPageMetadataBlockAutocomplete';
  Image?: Maybe<ContentModelReferenceAutocomplete>;
};

export type LocationListingPageMetadataBlockFacet = {
  __typename?: 'LocationListingPageMetadataBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  NoFollow?: Maybe<Array<Maybe<StringFacet>>>;
  NoIndex?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type LocationListingPageMetadataBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationListingPageMetadataBlockFacetNoFollowArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationListingPageMetadataBlockFacetNoIndexArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationListingPageMetadataBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationListingPageMetadataBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  NoFollow?: InputMaybe<OrderBy>;
  NoIndex?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type LocationListingPageMetadataBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  NoFollow?: InputMaybe<BoolFilterInput>;
  NoIndex?: InputMaybe<BoolFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type LocationListingPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BottomContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  ItemsPerPage?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Metadata?: InputMaybe<LocationListingPageMetadataBlockOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewDescription?: InputMaybe<OrderBy>;
  PreviewImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewTitle?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchCategories?: InputMaybe<CategoryModelOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  TopContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LocationListingPageOutput = {
  __typename?: 'LocationListingPageOutput';
  autocomplete?: Maybe<LocationListingPageAutocomplete>;
  cursor?: Maybe<Scalars['String']>;
  facets?: Maybe<LocationListingPageFacet>;
  item?: Maybe<LocationListingPage>;
  items?: Maybe<Array<Maybe<LocationListingPage>>>;
  total?: Maybe<Scalars['Int']>;
};


export type LocationListingPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type LocationListingPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BottomContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<StringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  ItemsPerPage?: InputMaybe<IntFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Metadata?: InputMaybe<LocationListingPageMetadataBlockWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewDescription?: InputMaybe<SearchableStringFilterInput>;
  PreviewImage?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewTitle?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchCategories?: InputMaybe<CategoryModelWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TopContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LocationListingPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LocationListingPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LocationListingPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type LocationPage = IContent & IData & {
  __typename?: 'LocationPage';
  Address?: Maybe<Scalars['String']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  BannerPattern?: Maybe<Scalars['String']>;
  BannerTheme?: Maybe<Scalars['String']>;
  BodyContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Button?: Maybe<LinkItemNode>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  Country?: Maybe<ContentModelReference>;
  Created?: Maybe<Scalars['Date']>;
  EmailAddress?: Maybe<Scalars['String']>;
  /** When checked, this page will not be displayed on the search results page. */
  ExcludeFromSearch?: Maybe<Scalars['Bool']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FaxNumber?: Maybe<Scalars['String']>;
  FileSize?: Maybe<Scalars['String']>;
  /** Aspect ratio: 16/9 */
  Image?: Maybe<LocationPagePictureProfile>;
  IsCommonDraft?: Maybe<Scalars['Bool']>;
  Language?: Maybe<ContentLanguageModel>;
  Latitude?: Maybe<Scalars['String']>;
  Longitude?: Maybe<Scalars['String']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Metadata?: Maybe<LocationPageMetadataBlock>;
  Name?: Maybe<Scalars['String']>;
  ParentLink?: Maybe<ContentModelReference>;
  PhoneNumber?: Maybe<Scalars['String']>;
  /** Description text that is displayed in preview tiles throughout the site. */
  PreviewDescription?: Maybe<Scalars['String']>;
  /** Overrides the default image on the page to be displayed on preview tiles throughout the site. */
  PreviewImage?: Maybe<ContentModelReference>;
  /** Overrides the default title/name on the page to be displayed on preview tiles throughout the site. */
  PreviewTitle?: Maybe<Scalars['String']>;
  RegionCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  RelativePath?: Maybe<Scalars['String']>;
  RouteSegment?: Maybe<Scalars['String']>;
  Saved?: Maybe<Scalars['Date']>;
  SearchCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Shortcut?: Maybe<Scalars['String']>;
  SimpleAddress?: Maybe<Scalars['String']>;
  SiteId?: Maybe<Scalars['String']>;
  StartPublish?: Maybe<Scalars['Date']>;
  Status?: Maybe<Scalars['String']>;
  StopPublish?: Maybe<Scalars['Date']>;
  Text?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
  Url?: Maybe<Scalars['String']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _sortOrder?: Maybe<Scalars['Int']>;
  _track?: Maybe<Scalars['String']>;
};


export type LocationPageAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationPageBannerPatternArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationPageBannerThemeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationPageBodyContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationPageEmailAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationPageFaxNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationPageLatitudeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationPageLongitudeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationPagePhoneNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationPagePreviewDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationPagePreviewTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationPageTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationPageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LocationPageAutocomplete = {
  __typename?: 'LocationPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Button?: Maybe<LinkItemNodeAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  Country?: Maybe<ContentModelReferenceAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FileSize?: Maybe<Array<Maybe<Scalars['String']>>>;
  Image?: Maybe<LocationPagePictureProfileAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  Metadata?: Maybe<LocationPageMetadataBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PreviewImage?: Maybe<ContentModelReferenceAutocomplete>;
  RegionCategories?: Maybe<CategoryModelAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']>>>;
  SearchCategories?: Maybe<CategoryModelAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type LocationPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type LocationPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type LocationPageAutocompleteFileSizeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type LocationPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type LocationPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type LocationPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type LocationPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type LocationPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type LocationPageAutocompleteStatusArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type LocationPageAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type LocationPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type LocationPageFacet = {
  __typename?: 'LocationPageFacet';
  Address?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BannerPattern?: Maybe<Array<Maybe<StringFacet>>>;
  BannerTheme?: Maybe<Array<Maybe<StringFacet>>>;
  BodyContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  Button?: Maybe<LinkItemNodeFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Country?: Maybe<ContentModelReferenceFacet>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EmailAddress?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FaxNumber?: Maybe<Array<Maybe<StringFacet>>>;
  FileSize?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<LocationPagePictureProfileFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  Latitude?: Maybe<Array<Maybe<StringFacet>>>;
  Longitude?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Metadata?: Maybe<LocationPageMetadataBlockFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PhoneNumber?: Maybe<Array<Maybe<StringFacet>>>;
  PreviewDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PreviewImage?: Maybe<ContentModelReferenceFacet>;
  PreviewTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RegionCategories?: Maybe<CategoryModelFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchCategories?: Maybe<CategoryModelFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Text?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type LocationPageFacetAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetBannerPatternArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetBannerThemeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type LocationPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type LocationPageFacetEmailAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetFaxNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetLatitudeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetLongitudeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetPhoneNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetPreviewDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetPreviewTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type LocationPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type LocationPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type LocationPageFacetTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LocationPageMetadataBlock = {
  __typename?: 'LocationPageMetadataBlock';
  Description?: Maybe<Scalars['String']>;
  Image?: Maybe<ContentModelReference>;
  NoFollow?: Maybe<Scalars['Bool']>;
  NoIndex?: Maybe<Scalars['Bool']>;
  Title?: Maybe<Scalars['String']>;
};


export type LocationPageMetadataBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationPageMetadataBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type LocationPageMetadataBlockAutocomplete = {
  __typename?: 'LocationPageMetadataBlockAutocomplete';
  Image?: Maybe<ContentModelReferenceAutocomplete>;
};

export type LocationPageMetadataBlockFacet = {
  __typename?: 'LocationPageMetadataBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  NoFollow?: Maybe<Array<Maybe<StringFacet>>>;
  NoIndex?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type LocationPageMetadataBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageMetadataBlockFacetNoFollowArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageMetadataBlockFacetNoIndexArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationPageMetadataBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationPageMetadataBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  NoFollow?: InputMaybe<OrderBy>;
  NoIndex?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type LocationPageMetadataBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  NoFollow?: InputMaybe<BoolFilterInput>;
  NoIndex?: InputMaybe<BoolFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type LocationPageOrderByInput = {
  Address?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  BannerPattern?: InputMaybe<OrderBy>;
  BannerTheme?: InputMaybe<OrderBy>;
  BodyContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Button?: InputMaybe<LinkItemNodeOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Country?: InputMaybe<ContentModelReferenceOrderByInput>;
  Created?: InputMaybe<OrderBy>;
  EmailAddress?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FaxNumber?: InputMaybe<OrderBy>;
  FileSize?: InputMaybe<OrderBy>;
  Image?: InputMaybe<LocationPagePictureProfileOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Latitude?: InputMaybe<OrderBy>;
  Longitude?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Metadata?: InputMaybe<LocationPageMetadataBlockOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PhoneNumber?: InputMaybe<OrderBy>;
  PreviewDescription?: InputMaybe<OrderBy>;
  PreviewImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewTitle?: InputMaybe<OrderBy>;
  RegionCategories?: InputMaybe<CategoryModelOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchCategories?: InputMaybe<CategoryModelOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Text?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LocationPageOutput = {
  __typename?: 'LocationPageOutput';
  autocomplete?: Maybe<LocationPageAutocomplete>;
  cursor?: Maybe<Scalars['String']>;
  facets?: Maybe<LocationPageFacet>;
  item?: Maybe<LocationPage>;
  items?: Maybe<Array<Maybe<LocationPage>>>;
  total?: Maybe<Scalars['Int']>;
};


export type LocationPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type LocationPagePictureProfile = {
  __typename?: 'LocationPagePictureProfile';
  DesktopImage?: Maybe<ContentModelReference>;
  MobileImage?: Maybe<ContentModelReference>;
  TabletImage?: Maybe<ContentModelReference>;
};

export type LocationPagePictureProfileAutocomplete = {
  __typename?: 'LocationPagePictureProfileAutocomplete';
  DesktopImage?: Maybe<ContentModelReferenceAutocomplete>;
  MobileImage?: Maybe<ContentModelReferenceAutocomplete>;
  TabletImage?: Maybe<ContentModelReferenceAutocomplete>;
};

export type LocationPagePictureProfileFacet = {
  __typename?: 'LocationPagePictureProfileFacet';
  DesktopImage?: Maybe<ContentModelReferenceFacet>;
  MobileImage?: Maybe<ContentModelReferenceFacet>;
  TabletImage?: Maybe<ContentModelReferenceFacet>;
};

export type LocationPagePictureProfileOrderByInput = {
  DesktopImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  MobileImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  TabletImage?: InputMaybe<ContentModelReferenceOrderByInput>;
};

export type LocationPagePictureProfileWhereInput = {
  DesktopImage?: InputMaybe<ContentModelReferenceWhereInput>;
  MobileImage?: InputMaybe<ContentModelReferenceWhereInput>;
  TabletImage?: InputMaybe<ContentModelReferenceWhereInput>;
};

export type LocationPageWhereInput = {
  Address?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  BannerPattern?: InputMaybe<SearchableStringFilterInput>;
  BannerTheme?: InputMaybe<SearchableStringFilterInput>;
  BodyContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Button?: InputMaybe<LinkItemNodeWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Country?: InputMaybe<ContentModelReferenceWhereInput>;
  Created?: InputMaybe<DateFilterInput>;
  EmailAddress?: InputMaybe<SearchableStringFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FaxNumber?: InputMaybe<SearchableStringFilterInput>;
  FileSize?: InputMaybe<StringFilterInput>;
  Image?: InputMaybe<LocationPagePictureProfileWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Latitude?: InputMaybe<SearchableStringFilterInput>;
  Longitude?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Metadata?: InputMaybe<LocationPageMetadataBlockWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  PreviewDescription?: InputMaybe<SearchableStringFilterInput>;
  PreviewImage?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewTitle?: InputMaybe<SearchableStringFilterInput>;
  RegionCategories?: InputMaybe<CategoryModelWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchCategories?: InputMaybe<CategoryModelWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Text?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LocationPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LocationPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LocationPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type NotFoundPage = IContent & IData & {
  __typename?: 'NotFoundPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  ButtonOne?: Maybe<LinkItemNode>;
  ButtonTwo?: Maybe<LinkItemNode>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  Created?: Maybe<Scalars['Date']>;
  /** When checked, this page will not be displayed on the search results page. */
  ExcludeFromSearch?: Maybe<Scalars['Bool']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['String']>;
  IsCommonDraft?: Maybe<Scalars['Bool']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Metadata?: Maybe<NotFoundPageMetadataBlock>;
  Name?: Maybe<Scalars['String']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Description text that is displayed in preview tiles throughout the site. */
  PreviewDescription?: Maybe<Scalars['String']>;
  /** Overrides the default image on the page to be displayed on preview tiles throughout the site. */
  PreviewImage?: Maybe<ContentModelReference>;
  /** Overrides the default title/name on the page to be displayed on preview tiles throughout the site. */
  PreviewTitle?: Maybe<Scalars['String']>;
  RelativePath?: Maybe<Scalars['String']>;
  RouteSegment?: Maybe<Scalars['String']>;
  Saved?: Maybe<Scalars['Date']>;
  SearchCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Shortcut?: Maybe<Scalars['String']>;
  SimpleAddress?: Maybe<Scalars['String']>;
  SiteId?: Maybe<Scalars['String']>;
  StartPublish?: Maybe<Scalars['Date']>;
  Status?: Maybe<Scalars['String']>;
  StopPublish?: Maybe<Scalars['Date']>;
  Text?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
  Url?: Maybe<Scalars['String']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _sortOrder?: Maybe<Scalars['Int']>;
  _track?: Maybe<Scalars['String']>;
};


export type NotFoundPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NotFoundPagePreviewDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NotFoundPagePreviewTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NotFoundPageTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NotFoundPageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NotFoundPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NotFoundPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NotFoundPageAutocomplete = {
  __typename?: 'NotFoundPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  ButtonOne?: Maybe<LinkItemNodeAutocomplete>;
  ButtonTwo?: Maybe<LinkItemNodeAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FileSize?: Maybe<Array<Maybe<Scalars['String']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  Metadata?: Maybe<NotFoundPageMetadataBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PreviewImage?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']>>>;
  SearchCategories?: Maybe<CategoryModelAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type NotFoundPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type NotFoundPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type NotFoundPageAutocompleteFileSizeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type NotFoundPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type NotFoundPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type NotFoundPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type NotFoundPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type NotFoundPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type NotFoundPageAutocompleteStatusArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type NotFoundPageAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type NotFoundPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type NotFoundPageFacet = {
  __typename?: 'NotFoundPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ButtonOne?: Maybe<LinkItemNodeFacet>;
  ButtonTwo?: Maybe<LinkItemNodeFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Metadata?: Maybe<NotFoundPageMetadataBlockFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreviewDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PreviewImage?: Maybe<ContentModelReferenceFacet>;
  PreviewTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchCategories?: Maybe<CategoryModelFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Text?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type NotFoundPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type NotFoundPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type NotFoundPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetPreviewDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetPreviewTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type NotFoundPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type NotFoundPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type NotFoundPageFacetTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NotFoundPageMetadataBlock = {
  __typename?: 'NotFoundPageMetadataBlock';
  Description?: Maybe<Scalars['String']>;
  Image?: Maybe<ContentModelReference>;
  NoFollow?: Maybe<Scalars['Bool']>;
  NoIndex?: Maybe<Scalars['Bool']>;
  Title?: Maybe<Scalars['String']>;
};


export type NotFoundPageMetadataBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NotFoundPageMetadataBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type NotFoundPageMetadataBlockAutocomplete = {
  __typename?: 'NotFoundPageMetadataBlockAutocomplete';
  Image?: Maybe<ContentModelReferenceAutocomplete>;
};

export type NotFoundPageMetadataBlockFacet = {
  __typename?: 'NotFoundPageMetadataBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  NoFollow?: Maybe<Array<Maybe<StringFacet>>>;
  NoIndex?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type NotFoundPageMetadataBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageMetadataBlockFacetNoFollowArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageMetadataBlockFacetNoIndexArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageMetadataBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NotFoundPageMetadataBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  NoFollow?: InputMaybe<OrderBy>;
  NoIndex?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type NotFoundPageMetadataBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  NoFollow?: InputMaybe<BoolFilterInput>;
  NoIndex?: InputMaybe<BoolFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type NotFoundPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  ButtonOne?: InputMaybe<LinkItemNodeOrderByInput>;
  ButtonTwo?: InputMaybe<LinkItemNodeOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Metadata?: InputMaybe<NotFoundPageMetadataBlockOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewDescription?: InputMaybe<OrderBy>;
  PreviewImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewTitle?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchCategories?: InputMaybe<CategoryModelOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Text?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NotFoundPageOutput = {
  __typename?: 'NotFoundPageOutput';
  autocomplete?: Maybe<NotFoundPageAutocomplete>;
  cursor?: Maybe<Scalars['String']>;
  facets?: Maybe<NotFoundPageFacet>;
  item?: Maybe<NotFoundPage>;
  items?: Maybe<Array<Maybe<NotFoundPage>>>;
  total?: Maybe<Scalars['Int']>;
};


export type NotFoundPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type NotFoundPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  ButtonOne?: InputMaybe<LinkItemNodeWhereInput>;
  ButtonTwo?: InputMaybe<LinkItemNodeWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<StringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Metadata?: InputMaybe<NotFoundPageMetadataBlockWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewDescription?: InputMaybe<SearchableStringFilterInput>;
  PreviewImage?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewTitle?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchCategories?: InputMaybe<CategoryModelWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Text?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NotFoundPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NotFoundPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NotFoundPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type NumberFacet = {
  __typename?: 'NumberFacet';
  count?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** Factor influences the score based of number values with a factor function */
export type NumberFactor = {
  modifier?: InputMaybe<FactorModifier>;
  value?: InputMaybe<Scalars['Float']>;
};

export enum OrderBy {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum OrderByFacetType {
  Count = 'COUNT',
  Value = 'VALUE'
}

export type PageBase = IContent & IData & {
  __typename?: 'PageBase';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  Created?: Maybe<Scalars['Date']>;
  /** When checked, this page will not be displayed on the search results page. */
  ExcludeFromSearch?: Maybe<Scalars['Bool']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['String']>;
  IsCommonDraft?: Maybe<Scalars['Bool']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Metadata?: Maybe<PageBaseMetadataBlock>;
  Name?: Maybe<Scalars['String']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Description text that is displayed in preview tiles throughout the site. */
  PreviewDescription?: Maybe<Scalars['String']>;
  /** Overrides the default image on the page to be displayed on preview tiles throughout the site. */
  PreviewImage?: Maybe<ContentModelReference>;
  /** Overrides the default title/name on the page to be displayed on preview tiles throughout the site. */
  PreviewTitle?: Maybe<Scalars['String']>;
  RelativePath?: Maybe<Scalars['String']>;
  RouteSegment?: Maybe<Scalars['String']>;
  Saved?: Maybe<Scalars['Date']>;
  SearchCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Shortcut?: Maybe<Scalars['String']>;
  SimpleAddress?: Maybe<Scalars['String']>;
  SiteId?: Maybe<Scalars['String']>;
  StartPublish?: Maybe<Scalars['Date']>;
  Status?: Maybe<Scalars['String']>;
  StopPublish?: Maybe<Scalars['Date']>;
  Url?: Maybe<Scalars['String']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _sortOrder?: Maybe<Scalars['Int']>;
  _track?: Maybe<Scalars['String']>;
};


export type PageBaseNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PageBasePreviewDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PageBasePreviewTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PageBase_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PageBase_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PageBaseAutocomplete = {
  __typename?: 'PageBaseAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FileSize?: Maybe<Array<Maybe<Scalars['String']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  Metadata?: Maybe<PageBaseMetadataBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PreviewImage?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']>>>;
  SearchCategories?: Maybe<CategoryModelAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type PageBaseAutocompleteAncestorsArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PageBaseAutocompleteContentTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PageBaseAutocompleteFileSizeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PageBaseAutocompleteRelativePathArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PageBaseAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PageBaseAutocompleteShortcutArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PageBaseAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PageBaseAutocompleteSiteIdArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PageBaseAutocompleteStatusArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PageBaseAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PageBaseAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type PageBaseFacet = {
  __typename?: 'PageBaseFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Metadata?: Maybe<PageBaseMetadataBlockFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreviewDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PreviewImage?: Maybe<ContentModelReferenceFacet>;
  PreviewTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchCategories?: Maybe<CategoryModelFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PageBaseFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PageBaseFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type PageBaseFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PageBaseFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type PageBaseFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PageBaseFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PageBaseFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PageBaseFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PageBaseFacetPreviewDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PageBaseFacetPreviewTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PageBaseFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PageBaseFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PageBaseFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type PageBaseFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PageBaseFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PageBaseFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PageBaseFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type PageBaseFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PageBaseFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type PageBaseFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PageBaseFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PageBaseFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PageBaseMetadataBlock = {
  __typename?: 'PageBaseMetadataBlock';
  Description?: Maybe<Scalars['String']>;
  Image?: Maybe<ContentModelReference>;
  NoFollow?: Maybe<Scalars['Bool']>;
  NoIndex?: Maybe<Scalars['Bool']>;
  Title?: Maybe<Scalars['String']>;
};


export type PageBaseMetadataBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PageBaseMetadataBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PageBaseMetadataBlockAutocomplete = {
  __typename?: 'PageBaseMetadataBlockAutocomplete';
  Image?: Maybe<ContentModelReferenceAutocomplete>;
};

export type PageBaseMetadataBlockFacet = {
  __typename?: 'PageBaseMetadataBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  NoFollow?: Maybe<Array<Maybe<StringFacet>>>;
  NoIndex?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PageBaseMetadataBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PageBaseMetadataBlockFacetNoFollowArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PageBaseMetadataBlockFacetNoIndexArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PageBaseMetadataBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PageBaseMetadataBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  NoFollow?: InputMaybe<OrderBy>;
  NoIndex?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type PageBaseMetadataBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  NoFollow?: InputMaybe<BoolFilterInput>;
  NoIndex?: InputMaybe<BoolFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type PageBaseOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Metadata?: InputMaybe<PageBaseMetadataBlockOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewDescription?: InputMaybe<OrderBy>;
  PreviewImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewTitle?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchCategories?: InputMaybe<CategoryModelOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PageBaseOutput = {
  __typename?: 'PageBaseOutput';
  autocomplete?: Maybe<PageBaseAutocomplete>;
  cursor?: Maybe<Scalars['String']>;
  facets?: Maybe<PageBaseFacet>;
  item?: Maybe<PageBase>;
  items?: Maybe<Array<Maybe<PageBase>>>;
  total?: Maybe<Scalars['Int']>;
};


export type PageBaseOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type PageBaseWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<StringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Metadata?: InputMaybe<PageBaseMetadataBlockWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewDescription?: InputMaybe<SearchableStringFilterInput>;
  PreviewImage?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewTitle?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchCategories?: InputMaybe<CategoryModelWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PageBaseWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PageBaseWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PageBaseWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type PdfFile = IContent & IData & {
  __typename?: 'PdfFile';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']>;
  Content?: Maybe<Scalars['String']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  Created?: Maybe<Scalars['Date']>;
  Description?: Maybe<Scalars['String']>;
  /** When checked, this page will not be displayed on the search results page. */
  ExcludeFromSearch?: Maybe<Scalars['Bool']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileExtension?: Maybe<Scalars['String']>;
  FileSize?: Maybe<Scalars['String']>;
  IsCommonDraft?: Maybe<Scalars['Bool']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MimeType?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Description text that is displayed in preview tiles throughout the site. */
  PreviewDescription?: Maybe<Scalars['String']>;
  /** Overrides the default image on the page to be displayed on preview tiles throughout the site. */
  PreviewImage?: Maybe<ContentModelReference>;
  /** Overrides the default title/name on the page to be displayed on preview tiles throughout the site. */
  PreviewTitle?: Maybe<Scalars['String']>;
  RelativePath?: Maybe<Scalars['String']>;
  RouteSegment?: Maybe<Scalars['String']>;
  Saved?: Maybe<Scalars['Date']>;
  SearchCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Shortcut?: Maybe<Scalars['String']>;
  SimpleAddress?: Maybe<Scalars['String']>;
  SiteId?: Maybe<Scalars['String']>;
  StartPublish?: Maybe<Scalars['Date']>;
  Status?: Maybe<Scalars['String']>;
  StopPublish?: Maybe<Scalars['Date']>;
  Thumbnail?: Maybe<BlobModel>;
  Url?: Maybe<Scalars['String']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _sortOrder?: Maybe<Scalars['Int']>;
  _track?: Maybe<Scalars['String']>;
};


export type PdfFileContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PdfFileDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PdfFileFileExtensionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PdfFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PdfFilePreviewDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PdfFilePreviewTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PdfFile_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PdfFile_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PdfFileAutocomplete = {
  __typename?: 'PdfFileAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FileSize?: Maybe<Array<Maybe<Scalars['String']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PreviewImage?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']>>>;
  SearchCategories?: Maybe<CategoryModelAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type PdfFileAutocompleteAncestorsArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PdfFileAutocompleteContentTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PdfFileAutocompleteFileSizeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PdfFileAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PdfFileAutocompleteRelativePathArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PdfFileAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PdfFileAutocompleteShortcutArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PdfFileAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PdfFileAutocompleteSiteIdArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PdfFileAutocompleteStatusArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PdfFileAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PdfFileAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type PdfFileFacet = {
  __typename?: 'PdfFileFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileExtension?: Maybe<Array<Maybe<StringFacet>>>;
  FileSize?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreviewDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PreviewImage?: Maybe<ContentModelReferenceFacet>;
  PreviewTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchCategories?: Maybe<CategoryModelFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PdfFileFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PdfFileFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type PdfFileFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PdfFileFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PdfFileFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type PdfFileFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PdfFileFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PdfFileFacetFileExtensionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PdfFileFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PdfFileFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PdfFileFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PdfFileFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PdfFileFacetPreviewDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PdfFileFacetPreviewTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PdfFileFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PdfFileFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PdfFileFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type PdfFileFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PdfFileFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PdfFileFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PdfFileFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type PdfFileFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PdfFileFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type PdfFileFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PdfFileFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PdfFileFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PdfFileOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileExtension?: InputMaybe<OrderBy>;
  FileSize?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewDescription?: InputMaybe<OrderBy>;
  PreviewImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewTitle?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchCategories?: InputMaybe<CategoryModelOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PdfFileOutput = {
  __typename?: 'PdfFileOutput';
  autocomplete?: Maybe<PdfFileAutocomplete>;
  cursor?: Maybe<Scalars['String']>;
  facets?: Maybe<PdfFileFacet>;
  item?: Maybe<PdfFile>;
  items?: Maybe<Array<Maybe<PdfFile>>>;
  total?: Maybe<Scalars['Int']>;
};


export type PdfFileOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type PdfFileWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileExtension?: InputMaybe<SearchableStringFilterInput>;
  FileSize?: InputMaybe<StringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewDescription?: InputMaybe<SearchableStringFilterInput>;
  PreviewImage?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewTitle?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchCategories?: InputMaybe<CategoryModelWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PdfFileWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PdfFileWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PdfFileWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type PeopleListingPage = IContent & IData & {
  __typename?: 'PeopleListingPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  BottomContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  Created?: Maybe<Scalars['Date']>;
  DisableSearchFilter?: Maybe<Scalars['Bool']>;
  /** When checked, this page will not be displayed on the search results page. */
  ExcludeFromSearch?: Maybe<Scalars['Bool']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['String']>;
  IsCommonDraft?: Maybe<Scalars['Bool']>;
  /** This value is not used when people are manually selected in the 'People' tab. */
  ItemsPerPage?: Maybe<Scalars['Int']>;
  Language?: Maybe<ContentLanguageModel>;
  ListingDescription?: Maybe<Scalars['String']>;
  ListingTitle?: Maybe<Scalars['String']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Metadata?: Maybe<PeopleListingPageMetadataBlock>;
  Name?: Maybe<Scalars['String']>;
  ParentLink?: Maybe<ContentModelReference>;
  PeopleContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  /** Description text that is displayed in preview tiles throughout the site. */
  PreviewDescription?: Maybe<Scalars['String']>;
  /** Overrides the default image on the page to be displayed on preview tiles throughout the site. */
  PreviewImage?: Maybe<ContentModelReference>;
  /** Overrides the default title/name on the page to be displayed on preview tiles throughout the site. */
  PreviewTitle?: Maybe<Scalars['String']>;
  RegionCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  RelativePath?: Maybe<Scalars['String']>;
  RouteSegment?: Maybe<Scalars['String']>;
  Saved?: Maybe<Scalars['Date']>;
  SearchCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Shortcut?: Maybe<Scalars['String']>;
  SimpleAddress?: Maybe<Scalars['String']>;
  SiteId?: Maybe<Scalars['String']>;
  StartPublish?: Maybe<Scalars['Date']>;
  Status?: Maybe<Scalars['String']>;
  StopPublish?: Maybe<Scalars['Date']>;
  Title?: Maybe<Scalars['String']>;
  TopContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Url?: Maybe<Scalars['String']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _sortOrder?: Maybe<Scalars['Int']>;
  _track?: Maybe<Scalars['String']>;
};


export type PeopleListingPageBottomContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PeopleListingPageListingDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PeopleListingPageListingTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PeopleListingPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PeopleListingPagePeopleContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PeopleListingPagePreviewDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PeopleListingPagePreviewTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PeopleListingPageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PeopleListingPageTopContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PeopleListingPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PeopleListingPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PeopleListingPageAutocomplete = {
  __typename?: 'PeopleListingPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FileSize?: Maybe<Array<Maybe<Scalars['String']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  Metadata?: Maybe<PeopleListingPageMetadataBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PreviewImage?: Maybe<ContentModelReferenceAutocomplete>;
  RegionCategories?: Maybe<CategoryModelAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']>>>;
  SearchCategories?: Maybe<CategoryModelAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type PeopleListingPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PeopleListingPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PeopleListingPageAutocompleteFileSizeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PeopleListingPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PeopleListingPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PeopleListingPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PeopleListingPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PeopleListingPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PeopleListingPageAutocompleteStatusArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PeopleListingPageAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PeopleListingPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type PeopleListingPageFacet = {
  __typename?: 'PeopleListingPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BottomContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchFilter?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  ItemsPerPage?: Maybe<Array<Maybe<NumberFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  ListingDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ListingTitle?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Metadata?: Maybe<PeopleListingPageMetadataBlockFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PeopleContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  PreviewDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PreviewImage?: Maybe<ContentModelReferenceFacet>;
  PreviewTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RegionCategories?: Maybe<CategoryModelFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchCategories?: Maybe<CategoryModelFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TopContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PeopleListingPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PeopleListingPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type PeopleListingPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PeopleListingPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type PeopleListingPageFacetDisableSearchFilterArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PeopleListingPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PeopleListingPageFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PeopleListingPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PeopleListingPageFacetItemsPerPageArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PeopleListingPageFacetListingDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PeopleListingPageFacetListingTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PeopleListingPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PeopleListingPageFacetPreviewDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PeopleListingPageFacetPreviewTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PeopleListingPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PeopleListingPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PeopleListingPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type PeopleListingPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PeopleListingPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PeopleListingPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PeopleListingPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type PeopleListingPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PeopleListingPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type PeopleListingPageFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PeopleListingPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PeopleListingPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PeopleListingPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PeopleListingPageMetadataBlock = {
  __typename?: 'PeopleListingPageMetadataBlock';
  Description?: Maybe<Scalars['String']>;
  Image?: Maybe<ContentModelReference>;
  NoFollow?: Maybe<Scalars['Bool']>;
  NoIndex?: Maybe<Scalars['Bool']>;
  Title?: Maybe<Scalars['String']>;
};


export type PeopleListingPageMetadataBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PeopleListingPageMetadataBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PeopleListingPageMetadataBlockAutocomplete = {
  __typename?: 'PeopleListingPageMetadataBlockAutocomplete';
  Image?: Maybe<ContentModelReferenceAutocomplete>;
};

export type PeopleListingPageMetadataBlockFacet = {
  __typename?: 'PeopleListingPageMetadataBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  NoFollow?: Maybe<Array<Maybe<StringFacet>>>;
  NoIndex?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PeopleListingPageMetadataBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PeopleListingPageMetadataBlockFacetNoFollowArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PeopleListingPageMetadataBlockFacetNoIndexArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PeopleListingPageMetadataBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PeopleListingPageMetadataBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  NoFollow?: InputMaybe<OrderBy>;
  NoIndex?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type PeopleListingPageMetadataBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  NoFollow?: InputMaybe<BoolFilterInput>;
  NoIndex?: InputMaybe<BoolFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type PeopleListingPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BottomContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchFilter?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  ItemsPerPage?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  ListingDescription?: InputMaybe<OrderBy>;
  ListingTitle?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Metadata?: InputMaybe<PeopleListingPageMetadataBlockOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PeopleContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  PreviewDescription?: InputMaybe<OrderBy>;
  PreviewImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewTitle?: InputMaybe<OrderBy>;
  RegionCategories?: InputMaybe<CategoryModelOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchCategories?: InputMaybe<CategoryModelOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  TopContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PeopleListingPageOutput = {
  __typename?: 'PeopleListingPageOutput';
  autocomplete?: Maybe<PeopleListingPageAutocomplete>;
  cursor?: Maybe<Scalars['String']>;
  facets?: Maybe<PeopleListingPageFacet>;
  item?: Maybe<PeopleListingPage>;
  items?: Maybe<Array<Maybe<PeopleListingPage>>>;
  total?: Maybe<Scalars['Int']>;
};


export type PeopleListingPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type PeopleListingPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BottomContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchFilter?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<StringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  ItemsPerPage?: InputMaybe<IntFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  ListingDescription?: InputMaybe<SearchableStringFilterInput>;
  ListingTitle?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Metadata?: InputMaybe<PeopleListingPageMetadataBlockWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PeopleContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  PreviewDescription?: InputMaybe<SearchableStringFilterInput>;
  PreviewImage?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewTitle?: InputMaybe<SearchableStringFilterInput>;
  RegionCategories?: InputMaybe<CategoryModelWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchCategories?: InputMaybe<CategoryModelWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TopContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PeopleListingPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PeopleListingPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PeopleListingPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type PersonPage = IContent & IData & {
  __typename?: 'PersonPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  ArticlesUrl?: Maybe<Scalars['String']>;
  BioText?: Maybe<Scalars['String']>;
  BioTitle?: Maybe<Scalars['String']>;
  BodyContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  Created?: Maybe<Scalars['Date']>;
  EmailAddress?: Maybe<Scalars['String']>;
  /** When checked, this page will not be displayed on the search results page. */
  ExcludeFromSearch?: Maybe<Scalars['Bool']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['String']>;
  HeadshotImage?: Maybe<ContentModelReference>;
  /** This page will return a 404, but can still be seen in the Search or Listing pages. */
  HideFromSite?: Maybe<Scalars['Bool']>;
  IsCommonDraft?: Maybe<Scalars['Bool']>;
  /** A full translatable joined text, as example, Joined 2016 */
  JoinedDateText?: Maybe<Scalars['String']>;
  Language?: Maybe<ContentLanguageModel>;
  LinkedInUrl?: Maybe<Scalars['String']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Metadata?: Maybe<PersonPageMetadataBlock>;
  Name?: Maybe<Scalars['String']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Description text that is displayed in preview tiles throughout the site. */
  PreviewDescription?: Maybe<Scalars['String']>;
  /** Overrides the default image on the page to be displayed on preview tiles throughout the site. */
  PreviewImage?: Maybe<ContentModelReference>;
  /** Overrides the default title/name on the page to be displayed on preview tiles throughout the site. */
  PreviewTitle?: Maybe<Scalars['String']>;
  RegionCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  RelativePath?: Maybe<Scalars['String']>;
  Role?: Maybe<Scalars['String']>;
  RouteSegment?: Maybe<Scalars['String']>;
  Saved?: Maybe<Scalars['Date']>;
  SearchCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Shortcut?: Maybe<Scalars['String']>;
  SimpleAddress?: Maybe<Scalars['String']>;
  SiteId?: Maybe<Scalars['String']>;
  StartPublish?: Maybe<Scalars['Date']>;
  Status?: Maybe<Scalars['String']>;
  StopPublish?: Maybe<Scalars['Date']>;
  TwitterUrl?: Maybe<Scalars['String']>;
  Url?: Maybe<Scalars['String']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _sortOrder?: Maybe<Scalars['Int']>;
  _track?: Maybe<Scalars['String']>;
};


export type PersonPageArticlesUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonPageBioTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonPageBioTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonPageBodyContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonPageEmailAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonPageJoinedDateTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonPageLinkedInUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonPagePreviewDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonPagePreviewTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonPageRoleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonPageTwitterUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PersonPageAutocomplete = {
  __typename?: 'PersonPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FileSize?: Maybe<Array<Maybe<Scalars['String']>>>;
  HeadshotImage?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  Metadata?: Maybe<PersonPageMetadataBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PreviewImage?: Maybe<ContentModelReferenceAutocomplete>;
  RegionCategories?: Maybe<CategoryModelAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']>>>;
  SearchCategories?: Maybe<CategoryModelAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type PersonPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PersonPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PersonPageAutocompleteFileSizeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PersonPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PersonPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PersonPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PersonPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PersonPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PersonPageAutocompleteStatusArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PersonPageAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type PersonPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type PersonPageFacet = {
  __typename?: 'PersonPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ArticlesUrl?: Maybe<Array<Maybe<StringFacet>>>;
  BioText?: Maybe<Array<Maybe<StringFacet>>>;
  BioTitle?: Maybe<Array<Maybe<StringFacet>>>;
  BodyContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EmailAddress?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<StringFacet>>>;
  HeadshotImage?: Maybe<ContentModelReferenceFacet>;
  HideFromSite?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  JoinedDateText?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinkedInUrl?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Metadata?: Maybe<PersonPageMetadataBlockFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreviewDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PreviewImage?: Maybe<ContentModelReferenceFacet>;
  PreviewTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RegionCategories?: Maybe<CategoryModelFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  Role?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchCategories?: Maybe<CategoryModelFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TwitterUrl?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PersonPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacetArticlesUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacetBioTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacetBioTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type PersonPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type PersonPageFacetEmailAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacetHideFromSiteArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacetJoinedDateTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacetLinkedInUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacetPreviewDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacetPreviewTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacetRoleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type PersonPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type PersonPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type PersonPageFacetTwitterUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PersonPageMetadataBlock = {
  __typename?: 'PersonPageMetadataBlock';
  Description?: Maybe<Scalars['String']>;
  Image?: Maybe<ContentModelReference>;
  NoFollow?: Maybe<Scalars['Bool']>;
  NoIndex?: Maybe<Scalars['Bool']>;
  Title?: Maybe<Scalars['String']>;
};


export type PersonPageMetadataBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonPageMetadataBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PersonPageMetadataBlockAutocomplete = {
  __typename?: 'PersonPageMetadataBlockAutocomplete';
  Image?: Maybe<ContentModelReferenceAutocomplete>;
};

export type PersonPageMetadataBlockFacet = {
  __typename?: 'PersonPageMetadataBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  NoFollow?: Maybe<Array<Maybe<StringFacet>>>;
  NoIndex?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PersonPageMetadataBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageMetadataBlockFacetNoFollowArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageMetadataBlockFacetNoIndexArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonPageMetadataBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonPageMetadataBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  NoFollow?: InputMaybe<OrderBy>;
  NoIndex?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type PersonPageMetadataBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  NoFollow?: InputMaybe<BoolFilterInput>;
  NoIndex?: InputMaybe<BoolFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type PersonPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  ArticlesUrl?: InputMaybe<OrderBy>;
  BioText?: InputMaybe<OrderBy>;
  BioTitle?: InputMaybe<OrderBy>;
  BodyContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EmailAddress?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  HeadshotImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  HideFromSite?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  JoinedDateText?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinkedInUrl?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Metadata?: InputMaybe<PersonPageMetadataBlockOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewDescription?: InputMaybe<OrderBy>;
  PreviewImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewTitle?: InputMaybe<OrderBy>;
  RegionCategories?: InputMaybe<CategoryModelOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  Role?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchCategories?: InputMaybe<CategoryModelOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TwitterUrl?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PersonPageOutput = {
  __typename?: 'PersonPageOutput';
  autocomplete?: Maybe<PersonPageAutocomplete>;
  cursor?: Maybe<Scalars['String']>;
  facets?: Maybe<PersonPageFacet>;
  item?: Maybe<PersonPage>;
  items?: Maybe<Array<Maybe<PersonPage>>>;
  total?: Maybe<Scalars['Int']>;
};


export type PersonPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type PersonPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  ArticlesUrl?: InputMaybe<SearchableStringFilterInput>;
  BioText?: InputMaybe<SearchableStringFilterInput>;
  BioTitle?: InputMaybe<SearchableStringFilterInput>;
  BodyContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EmailAddress?: InputMaybe<SearchableStringFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<StringFilterInput>;
  HeadshotImage?: InputMaybe<ContentModelReferenceWhereInput>;
  HideFromSite?: InputMaybe<BoolFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  JoinedDateText?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinkedInUrl?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Metadata?: InputMaybe<PersonPageMetadataBlockWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewDescription?: InputMaybe<SearchableStringFilterInput>;
  PreviewImage?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewTitle?: InputMaybe<SearchableStringFilterInput>;
  RegionCategories?: InputMaybe<CategoryModelWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  Role?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchCategories?: InputMaybe<CategoryModelWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TwitterUrl?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PersonPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PersonPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PersonPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type Query = {
  __typename?: 'Query';
  ArticleListingPage?: Maybe<ArticleListingPageOutput>;
  ArticlePage?: Maybe<ArticlePageOutput>;
  AssetListingPage?: Maybe<AssetListingPageOutput>;
  AssetPage?: Maybe<AssetPageOutput>;
  CalculatorDefaultPage?: Maybe<CalculatorDefaultPageOutput>;
  CalculatorFixedPage?: Maybe<CalculatorFixedPageOutput>;
  CalculatorSalaryContinuancePage?: Maybe<CalculatorSalaryContinuancePageOutput>;
  Content?: Maybe<ContentOutput>;
  Country?: Maybe<CountryOutput>;
  Data?: Maybe<DataOutput>;
  HomePage?: Maybe<HomePageOutput>;
  ImageFile?: Maybe<ImageFileOutput>;
  LocationListingPage?: Maybe<LocationListingPageOutput>;
  LocationPage?: Maybe<LocationPageOutput>;
  NotFoundPage?: Maybe<NotFoundPageOutput>;
  PageBase?: Maybe<PageBaseOutput>;
  PdfFile?: Maybe<PdfFileOutput>;
  PeopleListingPage?: Maybe<PeopleListingPageOutput>;
  PersonPage?: Maybe<PersonPageOutput>;
  SearchPage?: Maybe<SearchPageOutput>;
  SiteDefinition?: Maybe<SiteDefinitionOutput>;
  StandardPage?: Maybe<StandardPageOutput>;
  VectorImageFile?: Maybe<VectorImageFileOutput>;
};


export type QueryArticleListingPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ArticleListingPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ArticleListingPageWhereInput>;
};


export type QueryArticlePageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ArticlePageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ArticlePageWhereInput>;
};


export type QueryAssetListingPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AssetListingPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<AssetListingPageWhereInput>;
};


export type QueryAssetPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AssetPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<AssetPageWhereInput>;
};


export type QueryCalculatorDefaultPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CalculatorDefaultPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CalculatorDefaultPageWhereInput>;
};


export type QueryCalculatorFixedPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CalculatorFixedPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CalculatorFixedPageWhereInput>;
};


export type QueryCalculatorSalaryContinuancePageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CalculatorSalaryContinuancePageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CalculatorSalaryContinuancePageWhereInput>;
};


export type QueryContentArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContentOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ContentWhereInput>;
};


export type QueryCountryArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CountryOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CountryWhereInput>;
};


export type QueryDataArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<System_Locales>>>;
  orderBy?: InputMaybe<DataOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<DataWhereInput>;
};


export type QueryHomePageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HomePageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<HomePageWhereInput>;
};


export type QueryImageFileArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageFileOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ImageFileWhereInput>;
};


export type QueryLocationListingPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LocationListingPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<LocationListingPageWhereInput>;
};


export type QueryLocationPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LocationPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<LocationPageWhereInput>;
};


export type QueryNotFoundPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NotFoundPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<NotFoundPageWhereInput>;
};


export type QueryPageBaseArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PageBaseOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PageBaseWhereInput>;
};


export type QueryPdfFileArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PdfFileOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PdfFileWhereInput>;
};


export type QueryPeopleListingPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PeopleListingPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PeopleListingPageWhereInput>;
};


export type QueryPersonPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PersonPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PersonPageWhereInput>;
};


export type QuerySearchPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SearchPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SearchPageWhereInput>;
};


export type QuerySiteDefinitionArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteDefinitionOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SiteDefinitionWhereInput>;
};


export type QueryStandardPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<StandardPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<StandardPageWhereInput>;
};


export type QueryVectorImageFileArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VectorImageFileOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<VectorImageFileWhereInput>;
};

export type QueryRef = {
  __typename?: 'QueryRef';
  ArticleListingPage?: Maybe<ArticleListingPageOutput>;
  ArticlePage?: Maybe<ArticlePageOutput>;
  AssetListingPage?: Maybe<AssetListingPageOutput>;
  AssetPage?: Maybe<AssetPageOutput>;
  CalculatorDefaultPage?: Maybe<CalculatorDefaultPageOutput>;
  CalculatorFixedPage?: Maybe<CalculatorFixedPageOutput>;
  CalculatorSalaryContinuancePage?: Maybe<CalculatorSalaryContinuancePageOutput>;
  Content?: Maybe<ContentOutput>;
  Country?: Maybe<CountryOutput>;
  Data?: Maybe<DataOutput>;
  HomePage?: Maybe<HomePageOutput>;
  ImageFile?: Maybe<ImageFileOutput>;
  LocationListingPage?: Maybe<LocationListingPageOutput>;
  LocationPage?: Maybe<LocationPageOutput>;
  NotFoundPage?: Maybe<NotFoundPageOutput>;
  PageBase?: Maybe<PageBaseOutput>;
  PdfFile?: Maybe<PdfFileOutput>;
  PeopleListingPage?: Maybe<PeopleListingPageOutput>;
  PersonPage?: Maybe<PersonPageOutput>;
  SearchPage?: Maybe<SearchPageOutput>;
  SiteDefinition?: Maybe<SiteDefinitionOutput>;
  StandardPage?: Maybe<StandardPageOutput>;
  VectorImageFile?: Maybe<VectorImageFileOutput>;
};


export type QueryRefArticleListingPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ArticleListingPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ArticleListingPageWhereInput>;
};


export type QueryRefArticlePageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ArticlePageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ArticlePageWhereInput>;
};


export type QueryRefAssetListingPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AssetListingPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<AssetListingPageWhereInput>;
};


export type QueryRefAssetPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AssetPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<AssetPageWhereInput>;
};


export type QueryRefCalculatorDefaultPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CalculatorDefaultPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CalculatorDefaultPageWhereInput>;
};


export type QueryRefCalculatorFixedPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CalculatorFixedPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CalculatorFixedPageWhereInput>;
};


export type QueryRefCalculatorSalaryContinuancePageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CalculatorSalaryContinuancePageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CalculatorSalaryContinuancePageWhereInput>;
};


export type QueryRefContentArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContentOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ContentWhereInput>;
};


export type QueryRefCountryArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CountryOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CountryWhereInput>;
};


export type QueryRefDataArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<System_Locales>>>;
  orderBy?: InputMaybe<DataOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<DataWhereInput>;
};


export type QueryRefHomePageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HomePageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<HomePageWhereInput>;
};


export type QueryRefImageFileArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageFileOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ImageFileWhereInput>;
};


export type QueryRefLocationListingPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LocationListingPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<LocationListingPageWhereInput>;
};


export type QueryRefLocationPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LocationPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<LocationPageWhereInput>;
};


export type QueryRefNotFoundPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NotFoundPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<NotFoundPageWhereInput>;
};


export type QueryRefPageBaseArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PageBaseOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PageBaseWhereInput>;
};


export type QueryRefPdfFileArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PdfFileOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PdfFileWhereInput>;
};


export type QueryRefPeopleListingPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PeopleListingPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PeopleListingPageWhereInput>;
};


export type QueryRefPersonPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PersonPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PersonPageWhereInput>;
};


export type QueryRefSearchPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SearchPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SearchPageWhereInput>;
};


export type QueryRefSiteDefinitionArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteDefinitionOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SiteDefinitionWhereInput>;
};


export type QueryRefStandardPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<StandardPageOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<StandardPageWhereInput>;
};


export type QueryRefVectorImageFileArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: Scalars['Int'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VectorImageFileOrderByInput>;
  skip?: Scalars['Int'];
  track?: InputMaybe<Scalars['String']>;
  usePinned?: InputMaybe<UsePinnedInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<VectorImageFileWhereInput>;
};

export type RangeFacetsInput = {
  from?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['Int']>;
};

export enum Ranking {
  BoostOnly = 'BOOST_ONLY',
  Doc = 'DOC',
  Relevance = 'RELEVANCE',
  Semantic = 'SEMANTIC'
}

export type SearchPage = IContent & IData & {
  __typename?: 'SearchPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  CategoryFilters?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  Created?: Maybe<Scalars['Date']>;
  /** When checked, this page will not be displayed on the search results page. */
  ExcludeFromSearch?: Maybe<Scalars['Bool']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['String']>;
  IsCommonDraft?: Maybe<Scalars['Bool']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Metadata?: Maybe<SearchPageMetadataBlock>;
  Name?: Maybe<Scalars['String']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Description text that is displayed in preview tiles throughout the site. */
  PreviewDescription?: Maybe<Scalars['String']>;
  /** Overrides the default image on the page to be displayed on preview tiles throughout the site. */
  PreviewImage?: Maybe<ContentModelReference>;
  /** Overrides the default title/name on the page to be displayed on preview tiles throughout the site. */
  PreviewTitle?: Maybe<Scalars['String']>;
  RelativePath?: Maybe<Scalars['String']>;
  ResultsPerPage?: Maybe<Scalars['Int']>;
  RouteSegment?: Maybe<Scalars['String']>;
  Saved?: Maybe<Scalars['Date']>;
  SearchCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Shortcut?: Maybe<Scalars['String']>;
  SimpleAddress?: Maybe<Scalars['String']>;
  SiteId?: Maybe<Scalars['String']>;
  StartPublish?: Maybe<Scalars['Date']>;
  Status?: Maybe<Scalars['String']>;
  StopPublish?: Maybe<Scalars['Date']>;
  Url?: Maybe<Scalars['String']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _sortOrder?: Maybe<Scalars['Int']>;
  _track?: Maybe<Scalars['String']>;
};


export type SearchPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SearchPagePreviewDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SearchPagePreviewTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SearchPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SearchPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SearchPageAutocomplete = {
  __typename?: 'SearchPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  CategoryFilters?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FileSize?: Maybe<Array<Maybe<Scalars['String']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  Metadata?: Maybe<SearchPageMetadataBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PreviewImage?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']>>>;
  SearchCategories?: Maybe<CategoryModelAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type SearchPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type SearchPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type SearchPageAutocompleteFileSizeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type SearchPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type SearchPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type SearchPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type SearchPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type SearchPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type SearchPageAutocompleteStatusArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type SearchPageAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type SearchPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type SearchPageFacet = {
  __typename?: 'SearchPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  CategoryFilters?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Metadata?: Maybe<SearchPageMetadataBlockFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreviewDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PreviewImage?: Maybe<ContentModelReferenceFacet>;
  PreviewTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  ResultsPerPage?: Maybe<Array<Maybe<NumberFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchCategories?: Maybe<CategoryModelFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type SearchPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type SearchPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type SearchPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetPreviewDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetPreviewTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetResultsPerPageArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SearchPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type SearchPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type SearchPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type SearchPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SearchPageMetadataBlock = {
  __typename?: 'SearchPageMetadataBlock';
  Description?: Maybe<Scalars['String']>;
  Image?: Maybe<ContentModelReference>;
  NoFollow?: Maybe<Scalars['Bool']>;
  NoIndex?: Maybe<Scalars['Bool']>;
  Title?: Maybe<Scalars['String']>;
};


export type SearchPageMetadataBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SearchPageMetadataBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SearchPageMetadataBlockAutocomplete = {
  __typename?: 'SearchPageMetadataBlockAutocomplete';
  Image?: Maybe<ContentModelReferenceAutocomplete>;
};

export type SearchPageMetadataBlockFacet = {
  __typename?: 'SearchPageMetadataBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  NoFollow?: Maybe<Array<Maybe<StringFacet>>>;
  NoIndex?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SearchPageMetadataBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageMetadataBlockFacetNoFollowArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageMetadataBlockFacetNoIndexArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageMetadataBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchPageMetadataBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  NoFollow?: InputMaybe<OrderBy>;
  NoIndex?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type SearchPageMetadataBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  NoFollow?: InputMaybe<BoolFilterInput>;
  NoIndex?: InputMaybe<BoolFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type SearchPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  CategoryFilters?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Metadata?: InputMaybe<SearchPageMetadataBlockOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewDescription?: InputMaybe<OrderBy>;
  PreviewImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewTitle?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  ResultsPerPage?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchCategories?: InputMaybe<CategoryModelOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SearchPageOutput = {
  __typename?: 'SearchPageOutput';
  autocomplete?: Maybe<SearchPageAutocomplete>;
  cursor?: Maybe<Scalars['String']>;
  facets?: Maybe<SearchPageFacet>;
  item?: Maybe<SearchPage>;
  items?: Maybe<Array<Maybe<SearchPage>>>;
  total?: Maybe<Scalars['Int']>;
};


export type SearchPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type SearchPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  CategoryFilters?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<StringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Metadata?: InputMaybe<SearchPageMetadataBlockWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewDescription?: InputMaybe<SearchableStringFilterInput>;
  PreviewImage?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewTitle?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  ResultsPerPage?: InputMaybe<IntFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchCategories?: InputMaybe<CategoryModelWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SearchPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SearchPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SearchPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type SearchableStringFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']>;
  /** `contains` performs full-text search on a word or phrase. */
  contains?: InputMaybe<Scalars['String']>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['String']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']>;
  /** enables supporting fuzzy matching on the query terms (keywords), which returns items that contain terms in the content similar to the keywords, as measured by a _Levenshtein edit distance_. An edit distance is the number of one-character changes needed to turn one term into another. The edit distance is based on the length of the term.  */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** `in` matches with 1 or more exact values in a list. Example: `in: ["word1", "word2", "this is a phrase"]` */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** `like` matches on substrings with wildcard support: `%` to match on 0 or more characters, `_` to match on any character.  */
  like?: InputMaybe<Scalars['String']>;
  /** `match` performs full-text search on a word or phrase where less relevant items are also returned. The `match` operator is only supported for `searchable` fields. It will improve fulltext search by making it easier to match on words. More exact matches will be ranked higher, less exact matches will be ranked lower. The `match` operator is supported with synonyms and fuzzy search. */
  match?: InputMaybe<Scalars['String']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['String']>;
  /** `not_in` returns results that do not match with 1 or more exact values in a list. Example: `not_in: ["word1", "word2", "this is a phrase"]` */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** `starts_with` retrieves matches that start with a certain value (prefix). */
  startsWith?: InputMaybe<Scalars['String']>;
  /** expands query value with synonyms. Example: if `H2O` is a synonym of `water`, then querying for `water` will also return results with `H2O`. */
  synonyms?: InputMaybe<Array<InputMaybe<SynonymSlot>>>;
};

export type SiteDefinition = IData & {
  __typename?: 'SiteDefinition';
  ContentLink?: Maybe<ContentModelReference>;
  ContentRoots?: Maybe<ContentRootsModel>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  EditLocation?: Maybe<Scalars['String']>;
  Hosts?: Maybe<Array<Maybe<HostDefinitionModel>>>;
  Id?: Maybe<Scalars['String']>;
  Languages?: Maybe<Array<Maybe<SiteDefinitionLanguageModel>>>;
  Name?: Maybe<Scalars['String']>;
  Status?: Maybe<Scalars['String']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _track?: Maybe<Scalars['String']>;
};


export type SiteDefinitionNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteDefinition_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteDefinition_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SiteDefinitionAutocomplete = {
  __typename?: 'SiteDefinitionAutocomplete';
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentRoots?: Maybe<ContentRootsModelAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  EditLocation?: Maybe<Array<Maybe<Scalars['String']>>>;
  Hosts?: Maybe<HostDefinitionModelAutocomplete>;
  Id?: Maybe<Array<Maybe<Scalars['String']>>>;
  Languages?: Maybe<SiteDefinitionLanguageModelAutocomplete>;
  Status?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type SiteDefinitionAutocompleteContentTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type SiteDefinitionAutocompleteEditLocationArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type SiteDefinitionAutocompleteIdArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type SiteDefinitionAutocompleteStatusArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type SiteDefinitionFacet = {
  __typename?: 'SiteDefinitionFacet';
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentRoots?: Maybe<ContentRootsModelFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  EditLocation?: Maybe<Array<Maybe<StringFacet>>>;
  Hosts?: Maybe<HostDefinitionModelFacet>;
  Id?: Maybe<Array<Maybe<StringFacet>>>;
  Languages?: Maybe<SiteDefinitionLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SiteDefinitionFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionFacetEditLocationArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteDefinitionLanguageModel = {
  __typename?: 'SiteDefinitionLanguageModel';
  DisplayName?: Maybe<Scalars['String']>;
  IsMasterLanguage?: Maybe<Scalars['Bool']>;
  Name?: Maybe<Scalars['String']>;
  Url?: Maybe<Scalars['String']>;
  UrlSegment?: Maybe<Scalars['String']>;
};

export type SiteDefinitionLanguageModelAutocomplete = {
  __typename?: 'SiteDefinitionLanguageModelAutocomplete';
  DisplayName?: Maybe<Array<Maybe<Scalars['String']>>>;
  Name?: Maybe<Array<Maybe<Scalars['String']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
  UrlSegment?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type SiteDefinitionLanguageModelAutocompleteDisplayNameArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type SiteDefinitionLanguageModelAutocompleteNameArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type SiteDefinitionLanguageModelAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type SiteDefinitionLanguageModelAutocompleteUrlSegmentArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type SiteDefinitionLanguageModelFacet = {
  __typename?: 'SiteDefinitionLanguageModelFacet';
  DisplayName?: Maybe<Array<Maybe<StringFacet>>>;
  IsMasterLanguage?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  UrlSegment?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SiteDefinitionLanguageModelFacetDisplayNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionLanguageModelFacetIsMasterLanguageArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionLanguageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionLanguageModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionLanguageModelFacetUrlSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteDefinitionLanguageModelOrderByInput = {
  DisplayName?: InputMaybe<OrderBy>;
  IsMasterLanguage?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  UrlSegment?: InputMaybe<OrderBy>;
};

export type SiteDefinitionLanguageModelWhereInput = {
  DisplayName?: InputMaybe<StringFilterInput>;
  IsMasterLanguage?: InputMaybe<BoolFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  UrlSegment?: InputMaybe<StringFilterInput>;
};

export type SiteDefinitionOrderByInput = {
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentRoots?: InputMaybe<ContentRootsModelOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  EditLocation?: InputMaybe<OrderBy>;
  Hosts?: InputMaybe<HostDefinitionModelOrderByInput>;
  Id?: InputMaybe<OrderBy>;
  Languages?: InputMaybe<SiteDefinitionLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']>;
};

export type SiteDefinitionOutput = {
  __typename?: 'SiteDefinitionOutput';
  autocomplete?: Maybe<SiteDefinitionAutocomplete>;
  cursor?: Maybe<Scalars['String']>;
  facets?: Maybe<SiteDefinitionFacet>;
  item?: Maybe<SiteDefinition>;
  items?: Maybe<Array<Maybe<SiteDefinition>>>;
  total?: Maybe<Scalars['Int']>;
};


export type SiteDefinitionOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type SiteDefinitionWhereInput = {
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentRoots?: InputMaybe<ContentRootsModelWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  EditLocation?: InputMaybe<StringFilterInput>;
  Hosts?: InputMaybe<HostDefinitionModelWhereInput>;
  Id?: InputMaybe<StringFilterInput>;
  Languages?: InputMaybe<SiteDefinitionLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SiteDefinitionWhereInput>>>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SiteDefinitionWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SiteDefinitionWhereInput>>>;
};

export type StandardPage = IContent & IData & {
  __typename?: 'StandardPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']>;
  ContentBlocks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  Created?: Maybe<Scalars['Date']>;
  /** When checked, this page will not be displayed on the search results page. */
  ExcludeFromSearch?: Maybe<Scalars['Bool']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['String']>;
  IsCommonDraft?: Maybe<Scalars['Bool']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Metadata?: Maybe<StandardPageMetadataBlock>;
  Name?: Maybe<Scalars['String']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Description text that is displayed in preview tiles throughout the site. */
  PreviewDescription?: Maybe<Scalars['String']>;
  /** Overrides the default image on the page to be displayed on preview tiles throughout the site. */
  PreviewImage?: Maybe<ContentModelReference>;
  /** Overrides the default title/name on the page to be displayed on preview tiles throughout the site. */
  PreviewTitle?: Maybe<Scalars['String']>;
  RelativePath?: Maybe<Scalars['String']>;
  RouteSegment?: Maybe<Scalars['String']>;
  Saved?: Maybe<Scalars['Date']>;
  SearchCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Shortcut?: Maybe<Scalars['String']>;
  SimpleAddress?: Maybe<Scalars['String']>;
  SiteId?: Maybe<Scalars['String']>;
  StartPublish?: Maybe<Scalars['Date']>;
  Status?: Maybe<Scalars['String']>;
  StopPublish?: Maybe<Scalars['Date']>;
  Url?: Maybe<Scalars['String']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _sortOrder?: Maybe<Scalars['Int']>;
  _track?: Maybe<Scalars['String']>;
};


export type StandardPageContentBlocksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPagePreviewDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPagePreviewTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type StandardPageAutocomplete = {
  __typename?: 'StandardPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FileSize?: Maybe<Array<Maybe<Scalars['String']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  Metadata?: Maybe<StandardPageMetadataBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PreviewImage?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']>>>;
  SearchCategories?: Maybe<CategoryModelAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type StandardPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type StandardPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type StandardPageAutocompleteFileSizeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type StandardPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type StandardPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type StandardPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type StandardPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type StandardPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type StandardPageAutocompleteStatusArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type StandardPageAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type StandardPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type StandardPageFacet = {
  __typename?: 'StandardPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentBlocks?: Maybe<ContentAreaItemModelSearchFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Metadata?: Maybe<StandardPageMetadataBlockFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreviewDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PreviewImage?: Maybe<ContentModelReferenceFacet>;
  PreviewTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchCategories?: Maybe<CategoryModelFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type StandardPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type StandardPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type StandardPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageFacetPreviewDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageFacetPreviewTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type StandardPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type StandardPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type StandardPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type StandardPageMetadataBlock = {
  __typename?: 'StandardPageMetadataBlock';
  Description?: Maybe<Scalars['String']>;
  Image?: Maybe<ContentModelReference>;
  NoFollow?: Maybe<Scalars['Bool']>;
  NoIndex?: Maybe<Scalars['Bool']>;
  Title?: Maybe<Scalars['String']>;
};


export type StandardPageMetadataBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPageMetadataBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type StandardPageMetadataBlockAutocomplete = {
  __typename?: 'StandardPageMetadataBlockAutocomplete';
  Image?: Maybe<ContentModelReferenceAutocomplete>;
};

export type StandardPageMetadataBlockFacet = {
  __typename?: 'StandardPageMetadataBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  NoFollow?: Maybe<Array<Maybe<StringFacet>>>;
  NoIndex?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type StandardPageMetadataBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageMetadataBlockFacetNoFollowArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageMetadataBlockFacetNoIndexArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageMetadataBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StandardPageMetadataBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  NoFollow?: InputMaybe<OrderBy>;
  NoIndex?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type StandardPageMetadataBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  NoFollow?: InputMaybe<BoolFilterInput>;
  NoIndex?: InputMaybe<BoolFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type StandardPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentBlocks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Metadata?: InputMaybe<StandardPageMetadataBlockOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewDescription?: InputMaybe<OrderBy>;
  PreviewImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewTitle?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchCategories?: InputMaybe<CategoryModelOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type StandardPageOutput = {
  __typename?: 'StandardPageOutput';
  autocomplete?: Maybe<StandardPageAutocomplete>;
  cursor?: Maybe<Scalars['String']>;
  facets?: Maybe<StandardPageFacet>;
  item?: Maybe<StandardPage>;
  items?: Maybe<Array<Maybe<StandardPage>>>;
  total?: Maybe<Scalars['Int']>;
};


export type StandardPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type StandardPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentBlocks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<StringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Metadata?: InputMaybe<StandardPageMetadataBlockWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewDescription?: InputMaybe<SearchableStringFilterInput>;
  PreviewImage?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewTitle?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchCategories?: InputMaybe<CategoryModelWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<StandardPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<StandardPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<StandardPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type StringFacet = {
  __typename?: 'StringFacet';
  count?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type StringFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']>;
  /** `ends_with` retrieves matches that end with a certain value (suffix). */
  endsWith?: InputMaybe<Scalars['String']>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['String']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']>;
  /** enables supporting fuzzy matching on the query terms (keywords), which returns items that contain terms in the content similar to the keywords, as measured by a _Levenshtein edit distance_. An edit distance is the number of one-character changes needed to turn one term into another. The edit distance is based on the length of the term.  */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** `in` matches with 1 or more exact values in a list. Example: `in: ["word1", "word2", "this is a phrase"]` */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** `like` matches on substrings with wildcard support: `%` to match on 0 or more characters, `_` to match on any character.  */
  like?: InputMaybe<Scalars['String']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['String']>;
  /** `not_in` returns results that do not match with 1 or more exact values in a list. Example: `not_in: ["word1", "word2", "this is a phrase"]` */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** `starts_with` retrieves matches that start with a certain value (prefix). */
  startsWith?: InputMaybe<Scalars['String']>;
  /** expands query value with synonyms. Example: if `H2O` is a synonym of `water`, then querying for `water` will also return results with `H2O`. */
  synonyms?: InputMaybe<Array<InputMaybe<SynonymSlot>>>;
};

export enum SynonymSlot {
  /** synonym slot 1 */
  One = 'ONE',
  /** synonym slot 2 */
  Two = 'TWO'
}

export enum VariationIncludeMode {
  All = 'ALL',
  None = 'NONE',
  Some = 'SOME'
}

export type VariationInput = {
  include?: InputMaybe<VariationIncludeMode>;
  includeOriginal?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VectorImageFile = IContent & IData & {
  __typename?: 'VectorImageFile';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']>;
  Content?: Maybe<Scalars['String']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  Created?: Maybe<Scalars['Date']>;
  /** Used as alt tag. Name will be used when empty */
  Description?: Maybe<Scalars['String']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileExtension?: Maybe<Scalars['String']>;
  FileSize?: Maybe<Scalars['String']>;
  Height?: Maybe<Scalars['Int']>;
  IsCommonDraft?: Maybe<Scalars['Bool']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MimeType?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']>;
  RouteSegment?: Maybe<Scalars['String']>;
  Saved?: Maybe<Scalars['Date']>;
  SearchCategories?: Maybe<Array<Maybe<CategoryModel>>>;
  Shortcut?: Maybe<Scalars['String']>;
  SimpleAddress?: Maybe<Scalars['String']>;
  SiteId?: Maybe<Scalars['String']>;
  StartPublish?: Maybe<Scalars['Date']>;
  Status?: Maybe<Scalars['String']>;
  StopPublish?: Maybe<Scalars['Date']>;
  Thumbnail?: Maybe<BlobModel>;
  /** Used for title tag. Name will be used when empty */
  Title?: Maybe<Scalars['String']>;
  Url?: Maybe<Scalars['String']>;
  Width?: Maybe<Scalars['Int']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']>;
  _deleted?: Maybe<Scalars['Bool']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']>>>;
  _id?: Maybe<Scalars['String']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']>;
  _score?: Maybe<Scalars['Float']>;
  _sortOrder?: Maybe<Scalars['Int']>;
  _track?: Maybe<Scalars['String']>;
};


export type VectorImageFileContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VectorImageFileDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VectorImageFileFileExtensionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VectorImageFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VectorImageFileTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VectorImageFile_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VectorImageFile_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type VectorImageFileAutocomplete = {
  __typename?: 'VectorImageFileAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FileSize?: Maybe<Array<Maybe<Scalars['String']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']>>>;
  SearchCategories?: Maybe<CategoryModelAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type VectorImageFileAutocompleteAncestorsArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type VectorImageFileAutocompleteContentTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type VectorImageFileAutocompleteFileSizeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type VectorImageFileAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type VectorImageFileAutocompleteRelativePathArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type VectorImageFileAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type VectorImageFileAutocompleteShortcutArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type VectorImageFileAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type VectorImageFileAutocompleteSiteIdArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type VectorImageFileAutocompleteStatusArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type VectorImageFileAutocompleteUrlArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};


export type VectorImageFileAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int'];
  value: Scalars['String'];
};

export type VectorImageFileFacet = {
  __typename?: 'VectorImageFileFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileExtension?: Maybe<Array<Maybe<StringFacet>>>;
  FileSize?: Maybe<Array<Maybe<StringFacet>>>;
  Height?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchCategories?: Maybe<CategoryModelFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Width?: Maybe<Array<Maybe<NumberFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type VectorImageFileFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VectorImageFileFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type VectorImageFileFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VectorImageFileFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VectorImageFileFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type VectorImageFileFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VectorImageFileFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VectorImageFileFacetFileExtensionArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VectorImageFileFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VectorImageFileFacetHeightArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type VectorImageFileFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VectorImageFileFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VectorImageFileFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VectorImageFileFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VectorImageFileFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VectorImageFileFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type VectorImageFileFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VectorImageFileFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VectorImageFileFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VectorImageFileFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type VectorImageFileFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VectorImageFileFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']>;
};


export type VectorImageFileFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VectorImageFileFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VectorImageFileFacetWidthArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type VectorImageFileFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VectorImageFileFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type VectorImageFileOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileExtension?: InputMaybe<OrderBy>;
  FileSize?: InputMaybe<OrderBy>;
  Height?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchCategories?: InputMaybe<CategoryModelOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Width?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type VectorImageFileOutput = {
  __typename?: 'VectorImageFileOutput';
  autocomplete?: Maybe<VectorImageFileAutocomplete>;
  cursor?: Maybe<Scalars['String']>;
  facets?: Maybe<VectorImageFileFacet>;
  item?: Maybe<VectorImageFile>;
  items?: Maybe<Array<Maybe<VectorImageFile>>>;
  total?: Maybe<Scalars['Int']>;
};


export type VectorImageFileOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type VectorImageFileWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileExtension?: InputMaybe<SearchableStringFilterInput>;
  FileSize?: InputMaybe<StringFilterInput>;
  Height?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchCategories?: InputMaybe<CategoryModelWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Width?: InputMaybe<IntFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<VectorImageFileWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<VectorImageFileWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<VectorImageFileWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export enum System_Locales {
  All = 'ALL',
  Neutral = 'NEUTRAL'
}

export type UsePinnedInput = {
  collectionId?: InputMaybe<Scalars['String']>;
  phrase?: InputMaybe<Scalars['String']>;
};
